import {
  IAllowableActivityDTO,
  IAllowableResponsibleDTO,
} from "../../models/currentUser";

export const mockCurrentUserAllowableResponsibles: IAllowableResponsibleDTO[] =
  [
    {
      lastName: "LAFLEUR",
      firstName: "REAL",
      id: 101863,
      userCode: "ULAFL8R",
      belongsToBoroughId: 1274,
      groups: [
        {
          id: 1407,
          name: "ANJ TRAVAUX PUBLICS OPERATIONS",
        },
      ],
    },
    {
      lastName: "DUCHARME",
      firstName: "PATRICK",
      id: 109864,
      userCode: "UDUCH8O",
      belongsToBoroughId: 87,
      groups: [
        {
          id: 115,
          name: "RDPPAT VOIRIE",
        },
      ],
    },
    {
      lastName: "LECLERC",
      firstName: "BRUNO",
      id: 13123,
      userCode: "ULECLYJ",
      belongsToBoroughId: 82,
      groups: [
        {
          id: 682,
          name: "MHM VOIRIE",
        },
      ],
    },
    {
      lastName: "Test",
      firstName: "TestMobile",
      id: 124020,
      userCode: "CGSNCM1",
      belongsToBoroughId: 1274,
      groups: [
        {
          id: 682,
          name: "MHM VOIRIE",
        },
        {
          id: 1735,
          name: "PERMIS ET INSPECTIONS GDT SUD OUEST",
        },
        {
          id: 585,
          name: "AQUEDUC EGOUT SUD OUEST",
        },
        {
          id: 115,
          name: "RDPPAT VOIRIE",
        },
        {
          id: 1739,
          name: "CARTE INFO NEIGE",
        },
        {
          id: 1539,
          name: "TP VOIRIE AGENTS TECHNIQUES",
        },
        {
          id: 1799,
          name: "VOIE PUBLIQUE DEPOTS ILLEGAUX",
        },
        {
          id: 1465,
          name: "PARC OPERATIONS SUD OUEST",
        },
        {
          id: 33,
          name: "EAU AQUEDUC EGOUT",
        },
        {
          id: 1562,
          name: "AGENTS BUREAU TRAVAUX PUBLICS ANJOU",
        },
        {
          id: 1744,
          name: "CIRCULATION SUD OUEST",
        },
        {
          id: 1737,
          name: "VOIRIE OPERATIONS SUD OUEST",
        },
        {
          id: 1407,
          name: "ANJ TRAVAUX PUBLICS OPERATIONS",
        },
        {
          id: 1540,
          name: "TP VOIRIE ASPHALTE",
        },
        {
          id: 29,
          name: "TP VOIRIE VM",
        },
        {
          id: 764,
          name: "IBSG VOIRIE",
        },
        {
          id: 1538,
          name: "EAU AQUEDUC EGOUTS",
        },
        {
          id: 1743,
          name: "ETUDES TECHNIQUES SUD OUEST",
        },
        {
          id: 553,
          name: "TP PARCS HORTICULTURE VM",
        },
        {
          id: 1895,
          name: "GROUPE TEST",
        },
      ],
    },
    {
      lastName: "Faye",
      firstName: "Sagoundioura",
      id: 32795,
      userCode: "UFAYESA",
      belongsToBoroughId: 84,
      groups: [
        {
          id: 1539,
          name: "TP VOIRIE AGENTS TECHNIQUES",
        },
      ],
    },
    {
      lastName: "LEPAGE",
      firstName: "BENOIT",
      id: 100310,
      userCode: "ULEPABE",
      belongsToBoroughId: 84,
      groups: [
        {
          id: 553,
          name: "TP PARCS HORTICULTURE VM",
        },
      ],
    },
    {
      lastName: "SAULNIER",
      firstName: "KARL",
      id: 12843,
      userCode: "USAULKA",
      belongsToBoroughId: 84,
      groups: [
        {
          id: 1538,
          name: "EAU AQUEDUC EGOUTS",
        },
      ],
    },
    {
      lastName: "LACASSE",
      firstName: "JEAN",
      id: 103774,
      userCode: "ULACA9W",
      belongsToBoroughId: 84,
      groups: [
        {
          id: 553,
          name: "TP PARCS HORTICULTURE VM",
        },
      ],
    },
    {
      lastName: "PINNA",
      firstName: "SANDY",
      id: 1541,
      userCode: "UPINNSA",
      belongsToBoroughId: null,
      groups: [
        {
          id: 1739,
          name: "CARTE INFO NEIGE",
        },
        {
          id: 29,
          name: "TP VOIRIE VM",
        },
        {
          id: 553,
          name: "TP PARCS HORTICULTURE VM",
        },
        {
          id: 1538,
          name: "EAU AQUEDUC EGOUTS",
        },
        {
          id: 1539,
          name: "TP VOIRIE AGENTS TECHNIQUES",
        },
        {
          id: 1540,
          name: "TP VOIRIE ASPHALTE",
        },
      ],
    },
    {
      lastName: "Dufresne",
      firstName: "Alain",
      id: 3461,
      userCode: "UDUF998",
      belongsToBoroughId: 84,
      groups: [
        {
          id: 1540,
          name: "TP VOIRIE ASPHALTE",
        },
        {
          id: 1538,
          name: "EAU AQUEDUC EGOUTS",
        },
        {
          id: 29,
          name: "TP VOIRIE VM",
        },
      ],
    },
    {
      lastName: "LEGAULT",
      firstName: "DANIEL",
      id: 25448,
      userCode: "ULEGAZN",
      belongsToBoroughId: null,
      groups: [
        {
          id: 764,
          name: "IBSG VOIRIE",
        },
      ],
    },
    {
      lastName: "GORDON",
      firstName: "DONALD",
      id: 1659,
      userCode: "UGORDDO",
      belongsToBoroughId: 86,
      groups: [
        {
          id: 1743,
          name: "ETUDES TECHNIQUES SUD OUEST",
        },
      ],
    },
    {
      lastName: "DESSOURCES",
      firstName: "SAMUEL",
      id: 81101,
      userCode: "UDESSSA",
      belongsToBoroughId: 86,
      groups: [
        {
          id: 1737,
          name: "VOIRIE OPERATIONS SUD OUEST",
        },
        {
          id: 1465,
          name: "PARC OPERATIONS SUD OUEST",
        },
      ],
    },
    {
      lastName: "PARENT",
      firstName: "ISABELLE",
      id: 25342,
      userCode: "UPAREZF",
      belongsToBoroughId: 1274,
      groups: [
        {
          id: 1744,
          name: "CIRCULATION SUD OUEST",
        },
        {
          id: 1407,
          name: "ANJ TRAVAUX PUBLICS OPERATIONS",
        },
        {
          id: 1743,
          name: "ETUDES TECHNIQUES SUD OUEST",
        },
        {
          id: 585,
          name: "AQUEDUC EGOUT SUD OUEST",
        },
        {
          id: 1539,
          name: "TP VOIRIE AGENTS TECHNIQUES",
        },
        {
          id: 29,
          name: "TP VOIRIE VM",
        },
        {
          id: 1562,
          name: "AGENTS BUREAU TRAVAUX PUBLICS ANJOU",
        },
        {
          id: 1799,
          name: "VOIE PUBLIQUE DEPOTS ILLEGAUX",
        },
        {
          id: 1735,
          name: "PERMIS ET INSPECTIONS GDT SUD OUEST",
        },
        {
          id: 115,
          name: "RDPPAT VOIRIE",
        },
        {
          id: 1737,
          name: "VOIRIE OPERATIONS SUD OUEST",
        },
        {
          id: 1465,
          name: "PARC OPERATIONS SUD OUEST",
        },
      ],
    },
    {
      lastName: "DESBIENS",
      firstName: "JUSTINE",
      id: 113670,
      userCode: "UDESBJU",
      belongsToBoroughId: 86,
      groups: [
        {
          id: 1743,
          name: "ETUDES TECHNIQUES SUD OUEST",
        },
      ],
    },
    {
      lastName: "BOUTIN",
      firstName: "ANNIE",
      id: 117378,
      userCode: "UBOUT8A",
      belongsToBoroughId: 86,
      groups: [
        {
          id: 1743,
          name: "ETUDES TECHNIQUES SUD OUEST",
        },
      ],
    },
    {
      lastName: "SECK",
      firstName: "FATOU BINTOU FANY",
      id: 117218,
      userCode: "USECKFA",
      belongsToBoroughId: 86,
      groups: [
        {
          id: 1737,
          name: "VOIRIE OPERATIONS SUD OUEST",
        },
        {
          id: 585,
          name: "AQUEDUC EGOUT SUD OUEST",
        },
        {
          id: 1799,
          name: "VOIE PUBLIQUE DEPOTS ILLEGAUX",
        },
      ],
    },
    {
      lastName: "Landry",
      firstName: "Paul",
      id: 3366,
      userCode: "ULAND94",
      belongsToBoroughId: 86,
      groups: [
        {
          id: 585,
          name: "AQUEDUC EGOUT SUD OUEST",
        },
      ],
    },
    {
      lastName: "AUBUT",
      firstName: "GINETTE",
      id: 19973,
      userCode: "UAUBUGI",
      belongsToBoroughId: 1274,
      groups: [
        {
          id: 1407,
          name: "ANJ TRAVAUX PUBLICS OPERATIONS",
        },
      ],
    },
    {
      lastName: "Laframboise",
      firstName: "Jacques",
      id: 90907,
      userCode: "ULAFR9L",
      belongsToBoroughId: 82,
      groups: [
        {
          id: 682,
          name: "MHM VOIRIE",
        },
      ],
    },
    {
      lastName: "NETEDU",
      firstName: "CORINA-ISABELA",
      id: 98477,
      userCode: "UNETECO",
      belongsToBoroughId: 82,
      groups: [
        {
          id: 682,
          name: "MHM VOIRIE",
        },
      ],
    },
    {
      lastName: "ROY",
      firstName: "BRIGITTE",
      id: 18823,
      userCode: "UROYBRI",
      belongsToBoroughId: 82,
      groups: [
        {
          id: 682,
          name: "MHM VOIRIE",
        },
      ],
    },
    {
      lastName: "COALLIER",
      firstName: "LOUIS-PHILIP",
      id: 16967,
      userCode: "UCOALLO",
      belongsToBoroughId: 82,
      groups: [
        {
          id: 682,
          name: "MHM VOIRIE",
        },
      ],
    },
    {
      lastName: "NOLIN",
      firstName: "PIERRE-OLIVIER",
      id: 102776,
      userCode: "UNOLI95",
      belongsToBoroughId: 87,
      groups: [
        {
          id: 115,
          name: "RDPPAT VOIRIE",
        },
      ],
    },
    {
      lastName: "MENARD",
      firstName: "JEAN-SEBASTIEN",
      id: 109875,
      userCode: "UMENA78",
      belongsToBoroughId: 87,
      groups: [
        {
          id: 115,
          name: "RDPPAT VOIRIE",
        },
      ],
    },
    {
      lastName: "Brown",
      firstName: "Bobby",
      id: 2212,
      userCode: "UBROWBO",
      belongsToBoroughId: 82,
      groups: [
        {
          id: 682,
          name: "MHM VOIRIE",
        },
      ],
    },
    {
      lastName: "BOIVIN",
      firstName: "MARIE-EVE",
      id: 2934,
      userCode: "UBOIVXX",
      belongsToBoroughId: 84,
      groups: [
        {
          id: 1739,
          name: "CARTE INFO NEIGE",
        },
      ],
    },
    {
      lastName: "TOUGAS",
      firstName: "MANON",
      id: 119926,
      userCode: "UTOUGMA",
      belongsToBoroughId: null,
      groups: [
        {
          id: 553,
          name: "TP PARCS HORTICULTURE VM",
        },
      ],
    },
    {
      lastName: "THIBEAULT",
      firstName: "ANDRE",
      id: 13143,
      userCode: "UTHIBXX",
      belongsToBoroughId: 84,
      groups: [
        {
          id: 1540,
          name: "TP VOIRIE ASPHALTE",
        },
      ],
    },
    {
      lastName: "PELLETIER",
      firstName: "DANIEL",
      id: 12083,
      userCode: "UPELLDA",
      belongsToBoroughId: 84,
      groups: [
        {
          id: 553,
          name: "TP PARCS HORTICULTURE VM",
        },
      ],
    },
    {
      lastName: "BOUGACI",
      firstName: "HAMIDA",
      id: 112048,
      userCode: "UBOUG9Z",
      belongsToBoroughId: null,
      groups: [
        {
          id: 553,
          name: "TP PARCS HORTICULTURE VM",
        },
      ],
    },
    {
      lastName: "LAZURE",
      firstName: "MARTIN",
      id: 28411,
      userCode: "ULAZUMA",
      belongsToBoroughId: 84,
      groups: [
        {
          id: 29,
          name: "TP VOIRIE VM",
        },
        {
          id: 1739,
          name: "CARTE INFO NEIGE",
        },
      ],
    },
    {
      lastName: "GDT_Test",
      firstName: "RequeteNum311",
      id: 124034,
      userCode: "XGDTTOU",
      belongsToBoroughId: 86,
      groups: [
        {
          id: 1539,
          name: "TP VOIRIE AGENTS TECHNIQUES",
        },
        {
          id: 115,
          name: "RDPPAT VOIRIE",
        },
        {
          id: 1737,
          name: "VOIRIE OPERATIONS SUD OUEST",
        },
        {
          id: 29,
          name: "TP VOIRIE VM",
        },
        {
          id: 553,
          name: "TP PARCS HORTICULTURE VM",
        },
        {
          id: 1465,
          name: "PARC OPERATIONS SUD OUEST",
        },
      ],
    },
    {
      lastName: "Hébert",
      firstName: "Michel",
      id: 123966,
      userCode: "XHEBEMI",
      belongsToBoroughId: 84,
      groups: [
        {
          id: 553,
          name: "TP PARCS HORTICULTURE VM",
        },
        {
          id: 29,
          name: "TP VOIRIE VM",
        },
        {
          id: 1539,
          name: "TP VOIRIE AGENTS TECHNIQUES",
        },
        {
          id: 33,
          name: "EAU AQUEDUC EGOUT",
        },
      ],
    },
    {
      lastName: "Berube",
      firstName: "Stephane",
      id: 2245,
      userCode: "UBERUST",
      belongsToBoroughId: 84,
      groups: [
        {
          id: 29,
          name: "TP VOIRIE VM",
        },
      ],
    },
    {
      lastName: "BELANGER",
      firstName: "MARCEL",
      id: 3253,
      userCode: "UBELARR",
      belongsToBoroughId: 1286,
      groups: [
        {
          id: 764,
          name: "IBSG VOIRIE",
        },
      ],
    },
    {
      lastName: "LECLAIR",
      firstName: "ROBERT",
      id: 97738,
      userCode: "ULECL8V",
      belongsToBoroughId: 86,
      groups: [
        {
          id: 1743,
          name: "ETUDES TECHNIQUES SUD OUEST",
        },
        {
          id: 1744,
          name: "CIRCULATION SUD OUEST",
        },
      ],
    },
    {
      lastName: "LAFOND",
      firstName: "JOSEE",
      id: 112995,
      userCode: "ULAFO7Z",
      belongsToBoroughId: 86,
      groups: [
        {
          id: 1465,
          name: "PARC OPERATIONS SUD OUEST",
        },
      ],
    },
    {
      lastName: "FORTIN",
      firstName: "MELANIE",
      id: 93432,
      userCode: "UFORT7Y",
      belongsToBoroughId: 86,
      groups: [
        {
          id: 1744,
          name: "CIRCULATION SUD OUEST",
        },
        {
          id: 1799,
          name: "VOIE PUBLIQUE DEPOTS ILLEGAUX",
        },
        {
          id: 585,
          name: "AQUEDUC EGOUT SUD OUEST",
        },
        {
          id: 1743,
          name: "ETUDES TECHNIQUES SUD OUEST",
        },
        {
          id: 1737,
          name: "VOIRIE OPERATIONS SUD OUEST",
        },
      ],
    },
    {
      lastName: "HAMDANI",
      firstName: "CHAHRAZED",
      id: 99084,
      userCode: "UHAMDCH",
      belongsToBoroughId: 86,
      groups: [
        {
          id: 1744,
          name: "CIRCULATION SUD OUEST",
        },
        {
          id: 1737,
          name: "VOIRIE OPERATIONS SUD OUEST",
        },
        {
          id: 1799,
          name: "VOIE PUBLIQUE DEPOTS ILLEGAUX",
        },
        {
          id: 1743,
          name: "ETUDES TECHNIQUES SUD OUEST",
        },
        {
          id: 585,
          name: "AQUEDUC EGOUT SUD OUEST",
        },
        {
          id: 1465,
          name: "PARC OPERATIONS SUD OUEST",
        },
      ],
    },
    {
      lastName: "DINEL",
      firstName: "PIERRE",
      id: 3300,
      userCode: "UDINEPI",
      belongsToBoroughId: 86,
      groups: [
        {
          id: 1465,
          name: "PARC OPERATIONS SUD OUEST",
        },
      ],
    },
    {
      lastName: "TRUDEL",
      firstName: "MANON",
      id: 356,
      userCode: "UTRUDZQ",
      belongsToBoroughId: 1274,
      groups: [
        {
          id: 1407,
          name: "ANJ TRAVAUX PUBLICS OPERATIONS",
        },
        {
          id: 1562,
          name: "AGENTS BUREAU TRAVAUX PUBLICS ANJOU",
        },
      ],
    },
    {
      lastName: "LAMARCHE",
      firstName: "CONRAD",
      id: 3296,
      userCode: "ULAMA97",
      belongsToBoroughId: 1274,
      groups: [
        {
          id: 1407,
          name: "ANJ TRAVAUX PUBLICS OPERATIONS",
        },
      ],
    },
    {
      lastName: "THUOT",
      firstName: "JOCELYN",
      id: 119383,
      userCode: "UTHUOJO",
      belongsToBoroughId: 82,
      groups: [
        {
          id: 682,
          name: "MHM VOIRIE",
        },
      ],
    },
    {
      lastName: "HOULE",
      firstName: "DANY",
      id: 96702,
      userCode: "UHOUL9B",
      belongsToBoroughId: 87,
      groups: [
        {
          id: 115,
          name: "RDPPAT VOIRIE",
        },
      ],
    },
    {
      lastName: "DESCHESNES",
      firstName: "MARTIN",
      id: 3327,
      userCode: "UDESCZN",
      belongsToBoroughId: 87,
      groups: [
        {
          id: 115,
          name: "RDPPAT VOIRIE",
        },
      ],
    },
    {
      lastName: "MASSE",
      firstName: "MAXIME",
      id: 116139,
      userCode: "UMASS7K",
      belongsToBoroughId: 82,
      groups: [
        {
          id: 682,
          name: "MHM VOIRIE",
        },
      ],
    },
    {
      lastName: "OUELLETTE",
      firstName: "XAVIER",
      id: 115176,
      userCode: "UOUEL6K",
      belongsToBoroughId: 82,
      groups: [
        {
          id: 682,
          name: "MHM VOIRIE",
        },
      ],
    },
    {
      lastName: "DURAND",
      firstName: "FRANCOIS",
      id: 2214,
      userCode: "UDURAZT",
      belongsToBoroughId: 87,
      groups: [
        {
          id: 115,
          name: "RDPPAT VOIRIE",
        },
      ],
    },
    {
      lastName: "FERLAND",
      firstName: "LUCIE",
      id: 702,
      userCode: "UFERLZJ",
      belongsToBoroughId: 84,
      groups: [
        {
          id: 553,
          name: "TP PARCS HORTICULTURE VM",
        },
      ],
    },
    {
      lastName: "FORCIER",
      firstName: "MARIE-LAINE",
      id: 26039,
      userCode: "UFORCMA",
      belongsToBoroughId: null,
      groups: [
        {
          id: 1540,
          name: "TP VOIRIE ASPHALTE",
        },
        {
          id: 1539,
          name: "TP VOIRIE AGENTS TECHNIQUES",
        },
        {
          id: 1538,
          name: "EAU AQUEDUC EGOUTS",
        },
        {
          id: 33,
          name: "EAU AQUEDUC EGOUT",
        },
        {
          id: 29,
          name: "TP VOIRIE VM",
        },
        {
          id: 1739,
          name: "CARTE INFO NEIGE",
        },
      ],
    },
    {
      lastName: "LAROCHE",
      firstName: "HUGO",
      id: 116590,
      userCode: "ULAROHU",
      belongsToBoroughId: 84,
      groups: [
        {
          id: 29,
          name: "TP VOIRIE VM",
        },
        {
          id: 1540,
          name: "TP VOIRIE ASPHALTE",
        },
        {
          id: 1538,
          name: "EAU AQUEDUC EGOUTS",
        },
      ],
    },
    {
      lastName: "Lessard",
      firstName: "Diane",
      id: 22563,
      userCode: "ULESSDI",
      belongsToBoroughId: 1286,
      groups: [
        {
          id: 764,
          name: "IBSG VOIRIE",
        },
      ],
    },
    {
      lastName: "FRIGON",
      firstName: "PIERRE-LUC",
      id: 96300,
      userCode: "UFRIGPI",
      belongsToBoroughId: 86,
      groups: [
        {
          id: 1743,
          name: "ETUDES TECHNIQUES SUD OUEST",
        },
      ],
    },
    {
      lastName: "LEFEBVRE",
      firstName: "PATRICK",
      id: 101644,
      userCode: "ULEFE7W",
      belongsToBoroughId: 86,
      groups: [
        {
          id: 1743,
          name: "ETUDES TECHNIQUES SUD OUEST",
        },
      ],
    },
    {
      lastName: "GHANIMI",
      firstName: "MOLINE",
      id: 90893,
      userCode: "UGHANMO",
      belongsToBoroughId: 80,
      groups: [
        {
          id: 1743,
          name: "ETUDES TECHNIQUES SUD OUEST",
        },
      ],
    },
    {
      lastName: "Ledoux",
      firstName: "Caroline",
      id: 3434,
      userCode: "ULEDOCA",
      belongsToBoroughId: 86,
      groups: [
        {
          id: 1743,
          name: "ETUDES TECHNIQUES SUD OUEST",
        },
        {
          id: 1744,
          name: "CIRCULATION SUD OUEST",
        },
      ],
    },
    {
      lastName: "CODOI",
      firstName: "MELANIA ALEXANDRA",
      id: 114166,
      userCode: "UCODOME",
      belongsToBoroughId: 86,
      groups: [
        {
          id: 1743,
          name: "ETUDES TECHNIQUES SUD OUEST",
        },
        {
          id: 1735,
          name: "PERMIS ET INSPECTIONS GDT SUD OUEST",
        },
        {
          id: 585,
          name: "AQUEDUC EGOUT SUD OUEST",
        },
        {
          id: 1744,
          name: "CIRCULATION SUD OUEST",
        },
      ],
    },
    {
      lastName: "DOAN",
      firstName: "DANIEL HIEU",
      id: 100562,
      userCode: "UDOAN98",
      belongsToBoroughId: 86,
      groups: [
        {
          id: 1743,
          name: "ETUDES TECHNIQUES SUD OUEST",
        },
        {
          id: 1737,
          name: "VOIRIE OPERATIONS SUD OUEST",
        },
        {
          id: 1744,
          name: "CIRCULATION SUD OUEST",
        },
        {
          id: 1799,
          name: "VOIE PUBLIQUE DEPOTS ILLEGAUX",
        },
        {
          id: 1735,
          name: "PERMIS ET INSPECTIONS GDT SUD OUEST",
        },
        {
          id: 585,
          name: "AQUEDUC EGOUT SUD OUEST",
        },
      ],
    },
    {
      lastName: "PLOURDE",
      firstName: "SYLVAIN",
      id: 13389,
      userCode: "UPLOUSY",
      belongsToBoroughId: 86,
      groups: [
        {
          id: 585,
          name: "AQUEDUC EGOUT SUD OUEST",
        },
        {
          id: 1737,
          name: "VOIRIE OPERATIONS SUD OUEST",
        },
      ],
    },
    {
      lastName: "MASCIARELLI",
      firstName: "EDMONDO",
      id: 111981,
      userCode: "UMASCED",
      belongsToBoroughId: 86,
      groups: [
        {
          id: 1735,
          name: "PERMIS ET INSPECTIONS GDT SUD OUEST",
        },
        {
          id: 585,
          name: "AQUEDUC EGOUT SUD OUEST",
        },
        {
          id: 1744,
          name: "CIRCULATION SUD OUEST",
        },
        {
          id: 1743,
          name: "ETUDES TECHNIQUES SUD OUEST",
        },
      ],
    },
    {
      lastName: "FRECHETTE",
      firstName: "GUY",
      id: 15591,
      userCode: "UFRECGU",
      belongsToBoroughId: 1274,
      groups: [
        {
          id: 1407,
          name: "ANJ TRAVAUX PUBLICS OPERATIONS",
        },
      ],
    },
    {
      lastName: "Tremblay",
      firstName: "Luc",
      id: 19971,
      userCode: "UTREMPG",
      belongsToBoroughId: 1274,
      groups: [
        {
          id: 1407,
          name: "ANJ TRAVAUX PUBLICS OPERATIONS",
        },
      ],
    },
    {
      lastName: "Laroche",
      firstName: "Sylvie",
      id: 482,
      userCode: "ULAROZE",
      belongsToBoroughId: 82,
      groups: [
        {
          id: 682,
          name: "MHM VOIRIE",
        },
      ],
    },
    {
      lastName: "THIBAULT",
      firstName: "BRUNO",
      id: 1131,
      userCode: "UTHIBBR",
      belongsToBoroughId: 82,
      groups: [
        {
          id: 682,
          name: "MHM VOIRIE",
        },
      ],
    },
    {
      lastName: "SIMONEAU",
      firstName: "STEPHANIE",
      id: 101884,
      userCode: "USIMOST",
      belongsToBoroughId: null,
      groups: [
        {
          id: 682,
          name: "MHM VOIRIE",
        },
      ],
    },
    {
      lastName: "POITRAS",
      firstName: "DOMINIC",
      id: 30358,
      userCode: "UBOULXM",
      belongsToBoroughId: 80,
      groups: [
        {
          id: 115,
          name: "RDPPAT VOIRIE",
        },
      ],
    },
    {
      lastName: "SIMARD",
      firstName: "DANIEL",
      id: 3390,
      userCode: "USIMAXF",
      belongsToBoroughId: 87,
      groups: [
        {
          id: 115,
          name: "RDPPAT VOIRIE",
        },
      ],
    },
    {
      lastName: "WAGNER",
      firstName: "NATHALIE",
      id: 90696,
      userCode: "UWAGNNA",
      belongsToBoroughId: null,
      groups: [
        {
          id: 553,
          name: "TP PARCS HORTICULTURE VM",
        },
      ],
    },
    {
      lastName: "BISSONNETTE",
      firstName: "CHRISTIAN",
      id: 26501,
      userCode: "UBISSYX",
      belongsToBoroughId: 84,
      groups: [
        {
          id: 1538,
          name: "EAU AQUEDUC EGOUTS",
        },
      ],
    },
    {
      lastName: "Dubois",
      firstName: "Claude",
      id: 2209,
      userCode: "UDUBOCL",
      belongsToBoroughId: 84,
      groups: [
        {
          id: 1538,
          name: "EAU AQUEDUC EGOUTS",
        },
        {
          id: 29,
          name: "TP VOIRIE VM",
        },
      ],
    },
    {
      lastName: "BRISSON",
      firstName: "MARCEL",
      id: 26356,
      userCode: "UBRIS9P",
      belongsToBoroughId: 84,
      groups: [
        {
          id: 29,
          name: "TP VOIRIE VM",
        },
      ],
    },
    {
      lastName: "SIBONY",
      firstName: "SIMONE",
      id: 103769,
      userCode: "USIBO99",
      belongsToBoroughId: 1286,
      groups: [
        {
          id: 764,
          name: "IBSG VOIRIE",
        },
      ],
    },
    {
      lastName: "VERREAULT",
      firstName: "DENIS",
      id: 21797,
      userCode: "UVERRZQ",
      belongsToBoroughId: 86,
      groups: [
        {
          id: 1735,
          name: "PERMIS ET INSPECTIONS GDT SUD OUEST",
        },
        {
          id: 1744,
          name: "CIRCULATION SUD OUEST",
        },
      ],
    },
    {
      lastName: "ALLOUCH",
      firstName: "ISMAIL",
      id: 113609,
      userCode: "UALLOIS",
      belongsToBoroughId: 86,
      groups: [
        {
          id: 1735,
          name: "PERMIS ET INSPECTIONS GDT SUD OUEST",
        },
      ],
    },
    {
      lastName: "LEPAGE",
      firstName: "ERIC",
      id: 106883,
      userCode: "ULEPAER",
      belongsToBoroughId: null,
      groups: [
        {
          id: 1735,
          name: "PERMIS ET INSPECTIONS GDT SUD OUEST",
        },
        {
          id: 1744,
          name: "CIRCULATION SUD OUEST",
        },
        {
          id: 1743,
          name: "ETUDES TECHNIQUES SUD OUEST",
        },
      ],
    },
    {
      lastName: "LOPEZ",
      firstName: "ISABELLE",
      id: 28531,
      userCode: "ULOPEIS",
      belongsToBoroughId: 86,
      groups: [
        {
          id: 1737,
          name: "VOIRIE OPERATIONS SUD OUEST",
        },
      ],
    },
    {
      lastName: "Tessier",
      firstName: "Nadine",
      id: 1269,
      userCode: "UTESSYM",
      belongsToBoroughId: 86,
      groups: [
        {
          id: 1465,
          name: "PARC OPERATIONS SUD OUEST",
        },
      ],
    },
    {
      lastName: "BOISJOLI",
      firstName: "PATRICE",
      id: 117222,
      userCode: "UBOIS67",
      belongsToBoroughId: 86,
      groups: [
        {
          id: 1465,
          name: "PARC OPERATIONS SUD OUEST",
        },
      ],
    },
    {
      lastName: "IKHLEF",
      firstName: "AMAR",
      id: 96601,
      userCode: "UIKHLAM",
      belongsToBoroughId: 86,
      groups: [
        {
          id: 1737,
          name: "VOIRIE OPERATIONS SUD OUEST",
        },
        {
          id: 585,
          name: "AQUEDUC EGOUT SUD OUEST",
        },
      ],
    },
    {
      lastName: "LAMOUREUX",
      firstName: "MARCEL",
      id: 3343,
      userCode: "ULAMOWP",
      belongsToBoroughId: 86,
      groups: [
        {
          id: 1737,
          name: "VOIRIE OPERATIONS SUD OUEST",
        },
      ],
    },
    {
      lastName: "CALVO",
      firstName: "SORAYA",
      id: 26030,
      userCode: "UCALVSO",
      belongsToBoroughId: 82,
      groups: [
        {
          id: 682,
          name: "MHM VOIRIE",
        },
      ],
    },
    {
      lastName: "DUCHARME",
      firstName: "MAXIME",
      id: 95694,
      userCode: "UDUCH9D",
      belongsToBoroughId: 82,
      groups: [
        {
          id: 682,
          name: "MHM VOIRIE",
        },
      ],
    },
    {
      lastName: "BOUCHARD",
      firstName: "ROBERT",
      id: 3341,
      userCode: "UBOUCUP",
      belongsToBoroughId: 87,
      groups: [
        {
          id: 115,
          name: "RDPPAT VOIRIE",
        },
      ],
    },
    {
      lastName: "NOBERT",
      firstName: "ANDRE",
      id: 2211,
      userCode: "UNOBEAN",
      belongsToBoroughId: 82,
      groups: [
        {
          id: 682,
          name: "MHM VOIRIE",
        },
      ],
    },
    {
      lastName: "Lamoureux",
      firstName: "Stephane",
      id: 2215,
      userCode: "ULAMOZI",
      belongsToBoroughId: 82,
      groups: [
        {
          id: 682,
          name: "MHM VOIRIE",
        },
      ],
    },
    {
      lastName: "HARDY",
      firstName: "LAURENT",
      id: 2192,
      userCode: "UHARDLA",
      belongsToBoroughId: 87,
      groups: [
        {
          id: 115,
          name: "RDPPAT VOIRIE",
        },
      ],
    },
    {
      lastName: "BELAIR",
      firstName: "CLAIRETTE",
      id: 2213,
      userCode: "UBELAYC",
      belongsToBoroughId: 87,
      groups: [
        {
          id: 115,
          name: "RDPPAT VOIRIE",
        },
      ],
    },
    {
      lastName: "MARTIN",
      firstName: "ROBERT",
      id: 2240,
      userCode: "UMARTWM",
      belongsToBoroughId: 87,
      groups: [
        {
          id: 115,
          name: "RDPPAT VOIRIE",
        },
      ],
    },
    {
      lastName: "Turmel",
      firstName: "Alain",
      id: 13260,
      userCode: "UTURMAL",
      belongsToBoroughId: 84,
      groups: [
        {
          id: 553,
          name: "TP PARCS HORTICULTURE VM",
        },
      ],
    },
    {
      lastName: "MAROIS",
      firstName: "BRUNO",
      id: 3346,
      userCode: "UMAROBR",
      belongsToBoroughId: 86,
      groups: [
        {
          id: 29,
          name: "TP VOIRIE VM",
        },
      ],
    },
    {
      lastName: "OUIMET",
      firstName: "SERGE",
      id: 13108,
      userCode: "UOUIMSE",
      belongsToBoroughId: 84,
      groups: [
        {
          id: 29,
          name: "TP VOIRIE VM",
        },
      ],
    },
    {
      lastName: "Charbonneau",
      firstName: "Guy",
      id: 2038,
      userCode: "UCHARXP",
      belongsToBoroughId: 84,
      groups: [
        {
          id: 553,
          name: "TP PARCS HORTICULTURE VM",
        },
        {
          id: 29,
          name: "TP VOIRIE VM",
        },
      ],
    },
    {
      lastName: "LALIBERTE",
      firstName: "LISE",
      id: 3992,
      userCode: "ULALILI",
      belongsToBoroughId: 1286,
      groups: [
        {
          id: 764,
          name: "IBSG VOIRIE",
        },
      ],
    },
    {
      lastName: "LAREAU",
      firstName: "CHRISTINE",
      id: 22562,
      userCode: "ULARECH",
      belongsToBoroughId: 1286,
      groups: [
        {
          id: 764,
          name: "IBSG VOIRIE",
        },
      ],
    },
    {
      lastName: "ARCAND",
      firstName: "NATHALIE",
      id: 97302,
      userCode: "UARCANA",
      belongsToBoroughId: 86,
      groups: [
        {
          id: 1465,
          name: "PARC OPERATIONS SUD OUEST",
        },
        {
          id: 1737,
          name: "VOIRIE OPERATIONS SUD OUEST",
        },
      ],
    },
    {
      lastName: "VENNE",
      firstName: "MARTIN",
      id: 112441,
      userCode: "UVENN9W",
      belongsToBoroughId: 86,
      groups: [
        {
          id: 1465,
          name: "PARC OPERATIONS SUD OUEST",
        },
      ],
    },
    {
      lastName: "BOYTE",
      firstName: "BRIGITTE",
      id: 24672,
      userCode: "UBOYTBR",
      belongsToBoroughId: 86,
      groups: [
        {
          id: 1735,
          name: "PERMIS ET INSPECTIONS GDT SUD OUEST",
        },
      ],
    },
    {
      lastName: "NDEM NGOIDI",
      firstName: "SANGANDEM",
      id: 28591,
      userCode: "UNDEMSA",
      belongsToBoroughId: 86,
      groups: [
        {
          id: 1465,
          name: "PARC OPERATIONS SUD OUEST",
        },
        {
          id: 1737,
          name: "VOIRIE OPERATIONS SUD OUEST",
        },
      ],
    },
    {
      lastName: "MERCIER MORACHE",
      firstName: "JULES EMMANUEL",
      id: 114465,
      userCode: "UMERC8D",
      belongsToBoroughId: 86,
      groups: [
        {
          id: 1465,
          name: "PARC OPERATIONS SUD OUEST",
        },
      ],
    },
    {
      lastName: "PAQUET",
      firstName: "FRANCOIS",
      id: 15552,
      userCode: "UPAQUSM",
      belongsToBoroughId: 1274,
      groups: [
        {
          id: 1407,
          name: "ANJ TRAVAUX PUBLICS OPERATIONS",
        },
        {
          id: 1562,
          name: "AGENTS BUREAU TRAVAUX PUBLICS ANJOU",
        },
      ],
    },
    {
      lastName: "GENDRON",
      firstName: "ANNIE",
      id: 111312,
      userCode: "UGEND86",
      belongsToBoroughId: 1274,
      groups: [
        {
          id: 1562,
          name: "AGENTS BUREAU TRAVAUX PUBLICS ANJOU",
        },
        {
          id: 1407,
          name: "ANJ TRAVAUX PUBLICS OPERATIONS",
        },
      ],
    },
    {
      lastName: "Desloges",
      firstName: "Benoit",
      id: 3256,
      userCode: "UDESLYY",
      belongsToBoroughId: 1274,
      groups: [
        {
          id: 1562,
          name: "AGENTS BUREAU TRAVAUX PUBLICS ANJOU",
        },
        {
          id: 1407,
          name: "ANJ TRAVAUX PUBLICS OPERATIONS",
        },
      ],
    },
    {
      lastName: "COURTEMANCHE",
      firstName: "JULIEN",
      id: 114719,
      userCode: "UCOUR8Q",
      belongsToBoroughId: 82,
      groups: [
        {
          id: 682,
          name: "MHM VOIRIE",
        },
      ],
    },
    {
      lastName: "NORMANDIN",
      firstName: "MARIE-EVE",
      id: 98331,
      userCode: "UNORM9W",
      belongsToBoroughId: 82,
      groups: [
        {
          id: 682,
          name: "MHM VOIRIE",
        },
      ],
    },
    {
      lastName: "DUSSAULT",
      firstName: "MARC",
      id: 2876,
      userCode: "UDUSSMA",
      belongsToBoroughId: 82,
      groups: [
        {
          id: 682,
          name: "MHM VOIRIE",
        },
      ],
    },
    {
      lastName: "Lavigne",
      firstName: "Sylvain",
      id: 11947,
      userCode: "ULAVISY",
      belongsToBoroughId: 87,
      groups: [
        {
          id: 115,
          name: "RDPPAT VOIRIE",
        },
      ],
    },
    {
      lastName: "SIMARD",
      firstName: "RICHARD",
      id: 3364,
      userCode: "USIMAWY",
      belongsToBoroughId: 82,
      groups: [
        {
          id: 682,
          name: "MHM VOIRIE",
        },
      ],
    },
    {
      lastName: "ST-GELAIS",
      firstName: "LUC",
      id: 3344,
      userCode: "USTGEZO",
      belongsToBoroughId: 82,
      groups: [
        {
          id: 682,
          name: "MHM VOIRIE",
        },
      ],
    },
    {
      lastName: "Beauchamp",
      firstName: "Erik",
      id: 3356,
      userCode: "UBEAU96",
      belongsToBoroughId: 87,
      groups: [
        {
          id: 115,
          name: "RDPPAT VOIRIE",
        },
      ],
    },
    {
      lastName: "PAULHUS",
      firstName: "MANUEL",
      id: 24975,
      userCode: "UPAUL98",
      belongsToBoroughId: 82,
      groups: [
        {
          id: 682,
          name: "MHM VOIRIE",
        },
      ],
    },
    {
      lastName: "DIAZ",
      firstName: "ARAISBEL",
      id: 113648,
      userCode: "UDIAZAR",
      belongsToBoroughId: null,
      groups: [
        {
          id: 1895,
          name: "GROUPE TEST",
        },
      ],
    },
    {
      lastName: "Chamberland",
      firstName: "Alain",
      id: 18688,
      userCode: "UCHAMYY",
      belongsToBoroughId: 84,
      groups: [
        {
          id: 1538,
          name: "EAU AQUEDUC EGOUTS",
        },
      ],
    },
    {
      lastName: "ROY",
      firstName: "JULIE",
      id: 117013,
      userCode: "UROYJ9C",
      belongsToBoroughId: 84,
      groups: [
        {
          id: 1538,
          name: "EAU AQUEDUC EGOUTS",
        },
      ],
    },
    {
      lastName: "Fleury",
      firstName: "Marc",
      id: 3355,
      userCode: "UFLEUZS",
      belongsToBoroughId: 84,
      groups: [
        {
          id: 29,
          name: "TP VOIRIE VM",
        },
      ],
    },
    {
      lastName: "Berube",
      firstName: "Stephane (2245)",
      id: 123986,
      userCode: "XBERUST",
      belongsToBoroughId: 84,
      groups: [
        {
          id: 29,
          name: "TP VOIRIE VM",
        },
        {
          id: 33,
          name: "EAU AQUEDUC EGOUT",
        },
      ],
    },
    {
      lastName: "AIT ABDELKOUI",
      firstName: "SAFIA",
      id: 119098,
      userCode: "UAITA97",
      belongsToBoroughId: 85,
      groups: [
        {
          id: 1744,
          name: "CIRCULATION SUD OUEST",
        },
      ],
    },
    {
      lastName: "LIU",
      firstName: "CHANG",
      id: 115421,
      userCode: "ULIUCHA",
      belongsToBoroughId: null,
      groups: [
        {
          id: 1744,
          name: "CIRCULATION SUD OUEST",
        },
      ],
    },
    {
      lastName: "COTE",
      firstName: "DOMINIQUE",
      id: 108497,
      userCode: "UCOTE6K",
      belongsToBoroughId: null,
      groups: [
        {
          id: 1743,
          name: "ETUDES TECHNIQUES SUD OUEST",
        },
      ],
    },
    {
      lastName: "GAUTHIER",
      firstName: "BENOIT",
      id: 609,
      userCode: "UGAUTQI",
      belongsToBoroughId: 86,
      groups: [
        {
          id: 1737,
          name: "VOIRIE OPERATIONS SUD OUEST",
        },
      ],
    },
    {
      lastName: "LAFOND",
      firstName: "CELINE",
      id: 23732,
      userCode: "ULAFOCE",
      belongsToBoroughId: 86,
      groups: [
        {
          id: 1737,
          name: "VOIRIE OPERATIONS SUD OUEST",
        },
      ],
    },
    {
      lastName: "THERRIEN",
      firstName: "CLAIRE",
      id: 1270,
      userCode: "UTHERCL",
      belongsToBoroughId: 86,
      groups: [
        {
          id: 1465,
          name: "PARC OPERATIONS SUD OUEST",
        },
      ],
    },
    {
      lastName: "HURTUBISE",
      firstName: "STEPHANE",
      id: 99596,
      userCode: "UHURTST",
      belongsToBoroughId: 1274,
      groups: [
        {
          id: 1407,
          name: "ANJ TRAVAUX PUBLICS OPERATIONS",
        },
      ],
    },
    {
      lastName: "COUTURE",
      firstName: "PIERRE M.",
      id: 3295,
      userCode: "UCOUTXK",
      belongsToBoroughId: 1274,
      groups: [
        {
          id: 1407,
          name: "ANJ TRAVAUX PUBLICS OPERATIONS",
        },
      ],
    },
    {
      lastName: "BILLETTE",
      firstName: "PHILIPPE",
      id: 12220,
      userCode: "UBILLPH",
      belongsToBoroughId: 82,
      groups: [
        {
          id: 682,
          name: "MHM VOIRIE",
        },
      ],
    },
    {
      lastName: "COULOMBE",
      firstName: "SYLVAIN",
      id: 116188,
      userCode: "UCOUL9E",
      belongsToBoroughId: 82,
      groups: [
        {
          id: 682,
          name: "MHM VOIRIE",
        },
      ],
    },
    {
      lastName: "LAPOINTE",
      firstName: "SYLVIE",
      id: 24820,
      userCode: "ULAPOYY",
      belongsToBoroughId: 82,
      groups: [
        {
          id: 682,
          name: "MHM VOIRIE",
        },
      ],
    },
    {
      lastName: "BOUTHILLETTE",
      firstName: "VINCENT",
      id: 114422,
      userCode: "UBOUTVI",
      belongsToBoroughId: 82,
      groups: [
        {
          id: 682,
          name: "MHM VOIRIE",
        },
      ],
    },
    {
      lastName: "MORINVILLE",
      firstName: "NORMAND",
      id: 26628,
      userCode: "UMORI93",
      belongsToBoroughId: 87,
      groups: [
        {
          id: 115,
          name: "RDPPAT VOIRIE",
        },
      ],
    },
    {
      lastName: "RIOUX",
      firstName: "LINDA",
      id: 25601,
      userCode: "URIOUZQ",
      belongsToBoroughId: 87,
      groups: [
        {
          id: 115,
          name: "RDPPAT VOIRIE",
        },
      ],
    },
    {
      lastName: "Picard",
      firstName: "Christian",
      id: 3375,
      userCode: "UPICA94",
      belongsToBoroughId: 82,
      groups: [
        {
          id: 682,
          name: "MHM VOIRIE",
        },
      ],
    },
    {
      lastName: "COTE",
      firstName: "PASCAL",
      id: 13405,
      userCode: "UCOTEWY",
      belongsToBoroughId: 82,
      groups: [
        {
          id: 682,
          name: "MHM VOIRIE",
        },
      ],
    },
    {
      lastName: "ROUSSEAU",
      firstName: "PIERRE",
      id: 2242,
      userCode: "UROUSPI",
      belongsToBoroughId: 82,
      groups: [
        {
          id: 682,
          name: "MHM VOIRIE",
        },
      ],
    },
    {
      lastName: "Teixeira",
      firstName: "Paulo",
      id: 2190,
      userCode: "UTEIXPA",
      belongsToBoroughId: 87,
      groups: [
        {
          id: 115,
          name: "RDPPAT VOIRIE",
        },
      ],
    },
    {
      lastName: "DASSYLVA",
      firstName: "JULIE",
      id: 71893,
      userCode: "UDASSJU",
      belongsToBoroughId: 84,
      groups: [
        {
          id: 553,
          name: "TP PARCS HORTICULTURE VM",
        },
      ],
    },
    {
      lastName: "BOUCHARD",
      firstName: "ERIC",
      id: 72293,
      userCode: "UBOUC63",
      belongsToBoroughId: 84,
      groups: [
        {
          id: 553,
          name: "TP PARCS HORTICULTURE VM",
        },
      ],
    },
    {
      lastName: "Achille",
      firstName: "Richard",
      id: 396,
      userCode: "UACHIRI",
      belongsToBoroughId: null,
      groups: [
        {
          id: 1540,
          name: "TP VOIRIE ASPHALTE",
        },
      ],
    },
    {
      lastName: "NICOL",
      firstName: "CLAUDE",
      id: 36,
      userCode: "UNICOCL",
      belongsToBoroughId: 84,
      groups: [
        {
          id: 553,
          name: "TP PARCS HORTICULTURE VM",
        },
      ],
    },
    {
      lastName: "ABDELHAK",
      firstName: "YASMINA",
      id: 108581,
      userCode: "UABDE94",
      belongsToBoroughId: 84,
      groups: [
        {
          id: 1538,
          name: "EAU AQUEDUC EGOUTS",
        },
      ],
    },
    {
      lastName: "RANGER",
      firstName: "MARC",
      id: 23647,
      userCode: "URANGZZ",
      belongsToBoroughId: 84,
      groups: [
        {
          id: 1538,
          name: "EAU AQUEDUC EGOUTS",
        },
      ],
    },
    {
      lastName: "GUY",
      firstName: "BARBARA",
      id: 13273,
      userCode: "UGUYBAR",
      belongsToBoroughId: 84,
      groups: [
        {
          id: 553,
          name: "TP PARCS HORTICULTURE VM",
        },
      ],
    },
    {
      lastName: "LABELLE",
      firstName: "JEAN",
      id: 13087,
      userCode: "ULABEYT",
      belongsToBoroughId: 84,
      groups: [
        {
          id: 29,
          name: "TP VOIRIE VM",
        },
      ],
    },
    {
      lastName: "DUBOIS",
      firstName: "PIERRE (73156)",
      id: 123987,
      userCode: "XDUBO95",
      belongsToBoroughId: 84,
      groups: [
        {
          id: 553,
          name: "TP PARCS HORTICULTURE VM",
        },
      ],
    },
    {
      lastName: "BENBRAHIM",
      firstName: "HALIMA",
      id: 117608,
      userCode: "UBENB98",
      belongsToBoroughId: null,
      groups: [
        {
          id: 1744,
          name: "CIRCULATION SUD OUEST",
        },
      ],
    },
    {
      lastName: "FLOREA",
      firstName: "NICOLAE",
      id: 117133,
      userCode: "UFLOR92",
      belongsToBoroughId: 86,
      groups: [
        {
          id: 1799,
          name: "VOIE PUBLIQUE DEPOTS ILLEGAUX",
        },
      ],
    },
    {
      lastName: "ALLARD",
      firstName: "MARC",
      id: 113486,
      userCode: "UALLA7H",
      belongsToBoroughId: 86,
      groups: [
        {
          id: 1735,
          name: "PERMIS ET INSPECTIONS GDT SUD OUEST",
        },
      ],
    },
    {
      lastName: "ZIANI",
      firstName: "SAAD",
      id: 113567,
      userCode: "UZIAN99",
      belongsToBoroughId: 86,
      groups: [
        {
          id: 1735,
          name: "PERMIS ET INSPECTIONS GDT SUD OUEST",
        },
      ],
    },
    {
      lastName: "ESSADKI",
      firstName: "MOHAMED",
      id: 108479,
      userCode: "UESSA98",
      belongsToBoroughId: 86,
      groups: [
        {
          id: 1743,
          name: "ETUDES TECHNIQUES SUD OUEST",
        },
      ],
    },
    {
      lastName: "PERRET",
      firstName: "PATRICK",
      id: 529,
      userCode: "UPERRPA",
      belongsToBoroughId: 86,
      groups: [
        {
          id: 1465,
          name: "PARC OPERATIONS SUD OUEST",
        },
      ],
    },
    {
      lastName: "ASHBY",
      firstName: "DENIS",
      id: 23684,
      userCode: "UASHBDE",
      belongsToBoroughId: 86,
      groups: [
        {
          id: 1743,
          name: "ETUDES TECHNIQUES SUD OUEST",
        },
      ],
    },
    {
      lastName: "Caron",
      firstName: "Pierre",
      id: 1438,
      userCode: "UCAROWT",
      belongsToBoroughId: 86,
      groups: [
        {
          id: 1743,
          name: "ETUDES TECHNIQUES SUD OUEST",
        },
      ],
    },
    {
      lastName: "GAGNON",
      firstName: "PIERRE",
      id: 117375,
      userCode: "UGAGNN3",
      belongsToBoroughId: 86,
      groups: [
        {
          id: 1737,
          name: "VOIRIE OPERATIONS SUD OUEST",
        },
        {
          id: 1465,
          name: "PARC OPERATIONS SUD OUEST",
        },
      ],
    },
    {
      lastName: "SAVOIE",
      firstName: "MICHEL",
      id: 3317,
      userCode: "USAVOMI",
      belongsToBoroughId: 86,
      groups: [
        {
          id: 1737,
          name: "VOIRIE OPERATIONS SUD OUEST",
        },
      ],
    },
    {
      lastName: "GOURON",
      firstName: "MICHEL",
      id: 3367,
      userCode: "UGOUR99",
      belongsToBoroughId: 86,
      groups: [
        {
          id: 1737,
          name: "VOIRIE OPERATIONS SUD OUEST",
        },
      ],
    },
    {
      lastName: "GRISE",
      firstName: "RICHARD",
      id: 15580,
      userCode: "UGRISRI",
      belongsToBoroughId: 1274,
      groups: [
        {
          id: 1407,
          name: "ANJ TRAVAUX PUBLICS OPERATIONS",
        },
      ],
    },
    {
      lastName: "GOSSELIN",
      firstName: "MARJORIE",
      id: 114677,
      userCode: "UGOSS8F",
      belongsToBoroughId: 1274,
      groups: [
        {
          id: 1407,
          name: "ANJ TRAVAUX PUBLICS OPERATIONS",
        },
      ],
    },
    {
      lastName: "Franklin",
      firstName: "Stephanie",
      id: 18835,
      userCode: "UFRAN91",
      belongsToBoroughId: 87,
      groups: [
        {
          id: 115,
          name: "RDPPAT VOIRIE",
        },
      ],
    },
    {
      lastName: "MORZIERES",
      firstName: "DAVID",
      id: 95515,
      userCode: "UMORZDA",
      belongsToBoroughId: 87,
      groups: [
        {
          id: 115,
          name: "RDPPAT VOIRIE",
        },
      ],
    },
    {
      lastName: "BERTHELOT",
      firstName: "ROGER",
      id: 3203,
      userCode: "UBERTWA",
      belongsToBoroughId: 87,
      groups: [
        {
          id: 115,
          name: "RDPPAT VOIRIE",
        },
      ],
    },
    {
      lastName: "Gauvin",
      firstName: "Carole",
      id: 26181,
      userCode: "UGAUVZY",
      belongsToBoroughId: 87,
      groups: [
        {
          id: 115,
          name: "RDPPAT VOIRIE",
        },
      ],
    },
    {
      lastName: "DUBOIS",
      firstName: "SERGE",
      id: 107022,
      userCode: "UDUBO8D",
      belongsToBoroughId: 84,
      groups: [
        {
          id: 553,
          name: "TP PARCS HORTICULTURE VM",
        },
      ],
    },
    {
      lastName: "PIERRE",
      firstName: "JOSE",
      id: 12545,
      userCode: "UPIERZO",
      belongsToBoroughId: 84,
      groups: [
        {
          id: 553,
          name: "TP PARCS HORTICULTURE VM",
        },
      ],
    },
    {
      lastName: "DUBOIS",
      firstName: "PIERRE",
      id: 73156,
      userCode: "UDUBO95",
      belongsToBoroughId: 84,
      groups: [
        {
          id: 553,
          name: "TP PARCS HORTICULTURE VM",
        },
      ],
    },
    {
      lastName: "LABONTE",
      firstName: "JONATHAN",
      id: 121135,
      userCode: "ULABOJO",
      belongsToBoroughId: 84,
      groups: [
        {
          id: 1538,
          name: "EAU AQUEDUC EGOUTS",
        },
      ],
    },
    {
      lastName: "TREMBLAY",
      firstName: "LORRAINE",
      id: 12336,
      userCode: "UTREMTR",
      belongsToBoroughId: 84,
      groups: [
        {
          id: 553,
          name: "TP PARCS HORTICULTURE VM",
        },
      ],
    },
    {
      lastName: "CHENIER",
      firstName: "MICHEL",
      id: 3368,
      userCode: "UCHENMI",
      belongsToBoroughId: 84,
      groups: [
        {
          id: 29,
          name: "TP VOIRIE VM",
        },
      ],
    },
    {
      lastName: "ZELAYA",
      firstName: "JOSE RENE",
      id: 3381,
      userCode: "UZELA99",
      belongsToBoroughId: 84,
      groups: [
        {
          id: 29,
          name: "TP VOIRIE VM",
        },
      ],
    },
    {
      lastName: "DAVID",
      firstName: "JULIE",
      id: 1539,
      userCode: "UDAVIJU",
      belongsToBoroughId: 79,
      groups: [
        {
          id: 553,
          name: "TP PARCS HORTICULTURE VM",
        },
      ],
    },
    {
      lastName: "ALAO",
      firstName: "WASSI ABOUDOU",
      id: 116046,
      userCode: "UALAO99",
      belongsToBoroughId: 86,
      groups: [
        {
          id: 1743,
          name: "ETUDES TECHNIQUES SUD OUEST",
        },
      ],
    },
    {
      lastName: "LAFORCE-LAVOIE",
      firstName: "CORINNE",
      id: 113294,
      userCode: "ULAFO7Y",
      belongsToBoroughId: 86,
      groups: [
        {
          id: 1743,
          name: "ETUDES TECHNIQUES SUD OUEST",
        },
      ],
    },
    {
      lastName: "DESCOEURS",
      firstName: "SYLVAIN",
      id: 3202,
      userCode: "UDESCZQ",
      belongsToBoroughId: 86,
      groups: [
        {
          id: 1737,
          name: "VOIRIE OPERATIONS SUD OUEST",
        },
      ],
    },
  ];

export const mockCurrentUserAllowableActivities: IAllowableActivityDTO[] = [
  {
    id: 73,
    code: "GRA-DOM",
    name: "Graffitis - Domaine public",
    type: "ACTU",
    hasForm: false,
    boroughs: [
      {
        id: 82,
        name: "Mercier - Hochelaga-Maisonneuve",
        units: [
          {
            responsible: {
              id: 23356,
              name: "DIVISION DE LA VOIRIE",
            },
            group: {
              id: 682,
              name: "MHM VOIRIE",
            },
            templates: [
              {
                id: 385,
                name: "Grafitti",
              },
            ],
          },
        ],
      },
      {
        id: 84,
        name: "Ville-Marie",
        units: [
          {
            responsible: {
              id: 23287,
              name: "DIVISION DES PARCS ET DE L HORTICULTURE",
            },
            group: {
              id: 553,
              name: "TP PARCS HORTICULTURE VM",
            },
            templates: [
              {
                id: 385,
                name: "Grafitti",
              },
            ],
          },
          {
            responsible: {
              id: 23286,
              name: "DIVISION DE LA VOIRIE",
            },
            group: {
              id: 29,
              name: "TP VOIRIE VM",
            },
            templates: [
              {
                id: 385,
                name: "Grafitti",
              },
            ],
          },
        ],
      },
      {
        id: 86,
        name: "Le Sud-Ouest",
        units: [
          {
            responsible: {
              id: 23310,
              name: "DIVISION DE LA VOIRIE",
            },
            group: {
              id: 1465,
              name: "PARC OPERATIONS SUD OUEST",
            },
            templates: [
              {
                id: 385,
                name: "Grafitti",
              },
            ],
          },
        ],
      },
      {
        id: 87,
        name: "Rivière-des-Prairies - Pointe-aux-Trembles",
        units: [
          {
            responsible: {
              id: 23250,
              name: "DIVISION DE LA VOIRIE",
            },
            group: {
              id: 115,
              name: "RDPPAT VOIRIE",
            },
            templates: [
              {
                id: 385,
                name: "Grafitti",
              },
            ],
          },
        ],
      },
    ],
  },
  {
    id: 1650,
    code: "MOB-URB",
    name: "Mobilier urbain",
    type: "ACTU",
    hasForm: false,
    boroughs: [
      {
        id: 82,
        name: "Mercier - Hochelaga-Maisonneuve",
        units: [
          {
            responsible: {
              id: 23356,
              name: "DIVISION DE LA VOIRIE",
            },
            group: {
              id: 682,
              name: "MHM VOIRIE",
            },
            templates: [
              {
                id: 1649,
                name: "Voirie - Mobilier urbain",
              },
            ],
          },
        ],
      },
      {
        id: 87,
        name: "Rivière-des-Prairies - Pointe-aux-Trembles",
        units: [
          {
            responsible: {
              id: 23250,
              name: "DIVISION DE LA VOIRIE",
            },
            group: {
              id: 115,
              name: "RDPPAT VOIRIE",
            },
            templates: [
              {
                id: 1649,
                name: "Voirie - Mobilier urbain",
              },
            ],
          },
        ],
      },
      {
        id: 1274,
        name: "Anjou",
        units: [
          {
            responsible: {
              id: 26679,
              name: "DIVISION DES TRAVAUX PUBLICS",
            },
            group: {
              id: 1407,
              name: "ANJ TRAVAUX PUBLICS OPERATIONS",
            },
            templates: [
              {
                id: 1649,
                name: "Voirie - Mobilier urbain",
              },
            ],
          },
        ],
      },
      {
        id: 84,
        name: "Ville-Marie",
        units: [
          {
            responsible: {
              id: 23286,
              name: "DIVISION DE LA VOIRIE",
            },
            group: {
              id: 1539,
              name: "TP VOIRIE AGENTS TECHNIQUES",
            },
            templates: [
              {
                id: 1649,
                name: "Voirie - Mobilier urbain",
              },
              {
                id: 1649,
                name: "Voirie - Mobilier urbain",
              },
            ],
          },
        ],
      },
      {
        id: 86,
        name: "Le Sud-Ouest",
        units: [
          {
            responsible: {
              id: 23310,
              name: "DIVISION DE LA VOIRIE",
            },
            group: {
              id: 1737,
              name: "VOIRIE OPERATIONS SUD OUEST",
            },
            templates: [
              {
                id: 1649,
                name: "Voirie - Mobilier urbain",
              },
            ],
          },
        ],
      },
      {
        id: 1286,
        name: "L'Île-Bizard - Sainte-Geneviève",
        units: [
          {
            responsible: {
              id: 26473,
              name: "VOIRIE",
            },
            group: {
              id: 764,
              name: "IBSG VOIRIE",
            },
            templates: [
              {
                id: 1649,
                name: "Voirie - Mobilier urbain",
              },
            ],
          },
        ],
      },
    ],
  },
  {
    id: 68,
    code: "COL-DEC",
    name: "Collecte de déchets",
    type: "ACTU",
    hasForm: false,
    boroughs: [
      {
        id: 82,
        name: "Mercier - Hochelaga-Maisonneuve",
        units: [
          {
            responsible: {
              id: 23356,
              name: "DIVISION DE LA VOIRIE",
            },
            group: {
              id: 682,
              name: "MHM VOIRIE",
            },
            templates: [
              {
                id: 173,
                name: "Collecte déchets",
              },
            ],
          },
        ],
      },
      {
        id: 86,
        name: "Le Sud-Ouest",
        units: [
          {
            responsible: {
              id: 23310,
              name: "DIVISION DE LA VOIRIE",
            },
            group: {
              id: 1737,
              name: "VOIRIE OPERATIONS SUD OUEST",
            },
            templates: [
              {
                id: 173,
                name: "Collecte déchets",
              },
            ],
          },
        ],
      },
      {
        id: 87,
        name: "Rivière-des-Prairies - Pointe-aux-Trembles",
        units: [
          {
            responsible: {
              id: 23250,
              name: "DIVISION DE LA VOIRIE",
            },
            group: {
              id: 115,
              name: "RDPPAT VOIRIE",
            },
            templates: [
              {
                id: 173,
                name: "Collecte déchets",
              },
            ],
          },
        ],
      },
      {
        id: 84,
        name: "Ville-Marie",
        units: [
          {
            responsible: {
              id: 23286,
              name: "DIVISION DE LA VOIRIE",
            },
            group: {
              id: 1895,
              name: "GROUPE TEST",
            },
            templates: [
              {
                id: 173,
                name: "Collecte déchets",
              },
              {
                id: 173,
                name: "Collecte déchets",
              },
            ],
          },
        ],
      },
    ],
  },
  {
    id: 61,
    code: "BAL-MEC",
    name: "Balai mécanique",
    type: "ACTU",
    hasForm: false,
    boroughs: [
      {
        id: 82,
        name: "Mercier - Hochelaga-Maisonneuve",
        units: [
          {
            responsible: {
              id: 23356,
              name: "DIVISION DE LA VOIRIE",
            },
            group: {
              id: 682,
              name: "MHM VOIRIE",
            },
            templates: [
              {
                id: 166,
                name: "Balayage/net. De voies et empl publ.",
              },
            ],
          },
        ],
      },
      {
        id: 84,
        name: "Ville-Marie",
        units: [
          {
            responsible: {
              id: 23286,
              name: "DIVISION DE LA VOIRIE",
            },
            group: {
              id: 29,
              name: "TP VOIRIE VM",
            },
            templates: [
              {
                id: 166,
                name: "Balayage/net. De voies et empl publ.",
              },
            ],
          },
        ],
      },
      {
        id: 1286,
        name: "L'Île-Bizard - Sainte-Geneviève",
        units: [
          {
            responsible: {
              id: 26473,
              name: "VOIRIE",
            },
            group: {
              id: 764,
              name: "IBSG VOIRIE",
            },
            templates: [
              {
                id: 166,
                name: "Balayage/net. De voies et empl publ.",
              },
            ],
          },
        ],
      },
      {
        id: 86,
        name: "Le Sud-Ouest",
        units: [
          {
            responsible: {
              id: 23310,
              name: "DIVISION DE LA VOIRIE",
            },
            group: {
              id: 1737,
              name: "VOIRIE OPERATIONS SUD OUEST",
            },
            templates: [
              {
                id: 166,
                name: "Balayage/net. De voies et empl publ.",
              },
            ],
          },
        ],
      },
      {
        id: 1274,
        name: "Anjou",
        units: [
          {
            responsible: {
              id: 26679,
              name: "DIVISION DES TRAVAUX PUBLICS",
            },
            group: {
              id: 1407,
              name: "ANJ TRAVAUX PUBLICS OPERATIONS",
            },
            templates: [
              {
                id: 166,
                name: "Balayage/net. De voies et empl publ.",
              },
            ],
          },
        ],
      },
      {
        id: 87,
        name: "Rivière-des-Prairies - Pointe-aux-Trembles",
        units: [
          {
            responsible: {
              id: 23250,
              name: "DIVISION DE LA VOIRIE",
            },
            group: {
              id: 115,
              name: "RDPPAT VOIRIE",
            },
            templates: [
              {
                id: 166,
                name: "Balayage/net. De voies et empl publ.",
              },
            ],
          },
        ],
      },
    ],
  },
  {
    id: 3545,
    code: "COL-BRA",
    name: "Collecte de branches d'arbre - Agrile du frêne",
    type: "ACTU",
    hasForm: false,
    boroughs: [
      {
        id: 84,
        name: "Ville-Marie",
        units: [
          {
            responsible: {
              id: 23286,
              name: "DIVISION DE LA VOIRIE",
            },
            group: {
              id: 29,
              name: "TP VOIRIE VM",
            },
            templates: [
              {
                id: 2306,
                name: "Collecte de branches d'arbre",
              },
            ],
          },
          {
            responsible: {
              id: 23287,
              name: "DIVISION DES PARCS ET DE L HORTICULTURE",
            },
            group: {
              id: 553,
              name: "TP PARCS HORTICULTURE VM",
            },
            templates: [
              {
                id: 2306,
                name: "Collecte de branches d'arbre",
              },
            ],
          },
        ],
      },
      {
        id: 1274,
        name: "Anjou",
        units: [
          {
            responsible: {
              id: 26679,
              name: "DIVISION DES TRAVAUX PUBLICS",
            },
            group: {
              id: 1407,
              name: "ANJ TRAVAUX PUBLICS OPERATIONS",
            },
            templates: [
              {
                id: 2306,
                name: "Collecte de branches d'arbre",
              },
            ],
          },
          {
            responsible: {
              id: 24066,
              name: "DIRECTION DES TRAVAUX PUBLICS",
            },
            group: {
              id: 1562,
              name: "AGENTS BUREAU TRAVAUX PUBLICS ANJOU",
            },
            templates: [
              {
                id: 2306,
                name: "Collecte de branches d'arbre",
              },
            ],
          },
        ],
      },
      {
        id: 86,
        name: "Le Sud-Ouest",
        units: [
          {
            responsible: {
              id: 23310,
              name: "DIVISION DE LA VOIRIE",
            },
            group: {
              id: 1465,
              name: "PARC OPERATIONS SUD OUEST",
            },
            templates: [
              {
                id: 2306,
                name: "Collecte de branches d'arbre",
              },
            ],
          },
        ],
      },
      {
        id: 87,
        name: "Rivière-des-Prairies - Pointe-aux-Trembles",
        units: [
          {
            responsible: {
              id: 23250,
              name: "DIVISION DE LA VOIRIE",
            },
            group: {
              id: 115,
              name: "RDPPAT VOIRIE",
            },
            templates: [
              {
                id: 2306,
                name: "Collecte de branches d'arbre",
              },
            ],
          },
        ],
      },
    ],
  },
  {
    id: 107,
    code: "ELA-ARB",
    name: "Élagage",
    type: "ACTU",
    hasForm: false,
    boroughs: [
      {
        id: 84,
        name: "Ville-Marie",
        units: [
          {
            responsible: {
              id: 23286,
              name: "DIVISION DE LA VOIRIE",
            },
            group: {
              id: 1895,
              name: "GROUPE TEST",
            },
            templates: [
              {
                id: 329,
                name: "Inspection émondage",
              },
            ],
          },
          {
            responsible: {
              id: 23287,
              name: "DIVISION DES PARCS ET DE L HORTICULTURE",
            },
            group: {
              id: 553,
              name: "TP PARCS HORTICULTURE VM",
            },
            templates: [
              {
                id: 329,
                name: "Inspection émondage",
              },
            ],
          },
        ],
      },
      {
        id: 1274,
        name: "Anjou",
        units: [
          {
            responsible: {
              id: 26679,
              name: "DIVISION DES TRAVAUX PUBLICS",
            },
            group: {
              id: 1407,
              name: "ANJ TRAVAUX PUBLICS OPERATIONS",
            },
            templates: [
              {
                id: 329,
                name: "Inspection émondage",
              },
            ],
          },
        ],
      },
      {
        id: 86,
        name: "Le Sud-Ouest",
        units: [
          {
            responsible: {
              id: 23310,
              name: "DIVISION DE LA VOIRIE",
            },
            group: {
              id: 1465,
              name: "PARC OPERATIONS SUD OUEST",
            },
            templates: [
              {
                id: 329,
                name: "Inspection émondage",
              },
            ],
          },
        ],
      },
    ],
  },
  {
    id: 1647,
    code: "PAR-DIV",
    name: "Parc - Divers",
    type: "ACTU",
    hasForm: false,
    boroughs: [
      {
        id: 84,
        name: "Ville-Marie",
        units: [
          {
            responsible: {
              id: 23287,
              name: "DIVISION DES PARCS ET DE L HORTICULTURE",
            },
            group: {
              id: 553,
              name: "TP PARCS HORTICULTURE VM",
            },
            templates: [
              {
                id: 1345,
                name: "Inspection",
              },
            ],
          },
        ],
      },
      {
        id: 86,
        name: "Le Sud-Ouest",
        units: [
          {
            responsible: {
              id: 23310,
              name: "DIVISION DE LA VOIRIE",
            },
            group: {
              id: 1465,
              name: "PARC OPERATIONS SUD OUEST",
            },
            templates: [
              {
                id: 1345,
                name: "Inspection",
              },
            ],
          },
        ],
      },
    ],
  },
  {
    id: 655,
    code: "PAR-PRO",
    name: "Parc - Propreté",
    type: "ACTU",
    hasForm: false,
    boroughs: [
      {
        id: 84,
        name: "Ville-Marie",
        units: [
          {
            responsible: {
              id: 23287,
              name: "DIVISION DES PARCS ET DE L HORTICULTURE",
            },
            group: {
              id: 553,
              name: "TP PARCS HORTICULTURE VM",
            },
            templates: [
              {
                id: 331,
                name: "Inspection parc vandalisme",
              },
            ],
          },
        ],
      },
      {
        id: 86,
        name: "Le Sud-Ouest",
        units: [
          {
            responsible: {
              id: 23310,
              name: "DIVISION DE LA VOIRIE",
            },
            group: {
              id: 1465,
              name: "PARC OPERATIONS SUD OUEST",
            },
            templates: [
              {
                id: 331,
                name: "Inspection parc vandalisme",
              },
            ],
          },
        ],
      },
    ],
  },
  {
    id: 108,
    code: "HOR-ENT",
    name: "Horticulture - Entretien",
    type: "ACTU",
    hasForm: false,
    boroughs: [
      {
        id: 84,
        name: "Ville-Marie",
        units: [
          {
            responsible: {
              id: 23287,
              name: "DIVISION DES PARCS ET DE L HORTICULTURE",
            },
            group: {
              id: 553,
              name: "TP PARCS HORTICULTURE VM",
            },
            templates: [
              {
                id: 345,
                name: "Horticulture - Entretien",
              },
            ],
          },
        ],
      },
      {
        id: 1274,
        name: "Anjou",
        units: [
          {
            responsible: {
              id: 26679,
              name: "DIVISION DES TRAVAUX PUBLICS",
            },
            group: {
              id: 1407,
              name: "ANJ TRAVAUX PUBLICS OPERATIONS",
            },
            templates: [
              {
                id: 345,
                name: "Horticulture - Entretien",
              },
            ],
          },
        ],
      },
      {
        id: 86,
        name: "Le Sud-Ouest",
        units: [
          {
            responsible: {
              id: 23310,
              name: "DIVISION DE LA VOIRIE",
            },
            group: {
              id: 1465,
              name: "PARC OPERATIONS SUD OUEST",
            },
            templates: [
              {
                id: 345,
                name: "Horticulture - Entretien",
              },
            ],
          },
        ],
      },
    ],
  },
  {
    id: 103,
    code: "MAL-ARB",
    name: "Maladie ou insectes - Arbre",
    type: "ACTU",
    hasForm: false,
    boroughs: [
      {
        id: 84,
        name: "Ville-Marie",
        units: [
          {
            responsible: {
              id: 23287,
              name: "DIVISION DES PARCS ET DE L HORTICULTURE",
            },
            group: {
              id: 553,
              name: "TP PARCS HORTICULTURE VM",
            },
            templates: [
              {
                id: 326,
                name: "Inspection arbre malade",
              },
            ],
          },
        ],
      },
      {
        id: 1274,
        name: "Anjou",
        units: [
          {
            responsible: {
              id: 24066,
              name: "DIRECTION DES TRAVAUX PUBLICS",
            },
            group: {
              id: 1562,
              name: "AGENTS BUREAU TRAVAUX PUBLICS ANJOU",
            },
            templates: [
              {
                id: 326,
                name: "Inspection arbre malade",
              },
            ],
          },
          {
            responsible: {
              id: 26679,
              name: "DIVISION DES TRAVAUX PUBLICS",
            },
            group: {
              id: 1407,
              name: "ANJ TRAVAUX PUBLICS OPERATIONS",
            },
            templates: [
              {
                id: 326,
                name: "Inspection arbre malade",
              },
            ],
          },
        ],
      },
      {
        id: 86,
        name: "Le Sud-Ouest",
        units: [
          {
            responsible: {
              id: 23310,
              name: "DIVISION DE LA VOIRIE",
            },
            group: {
              id: 1465,
              name: "PARC OPERATIONS SUD OUEST",
            },
            templates: [
              {
                id: 326,
                name: "Inspection arbre malade",
              },
            ],
          },
        ],
      },
    ],
  },
  {
    id: 429,
    code: "COL-ENR",
    name: "Encombrants non ramassés",
    type: "ACTU",
    hasForm: false,
    boroughs: [
      {
        id: 84,
        name: "Ville-Marie",
        units: [
          {
            responsible: {
              id: 23286,
              name: "DIVISION DE LA VOIRIE",
            },
            group: {
              id: 29,
              name: "TP VOIRIE VM",
            },
            templates: [
              {
                id: 175,
                name: "Collecte régulière",
              },
            ],
          },
        ],
      },
      {
        id: 87,
        name: "Rivière-des-Prairies - Pointe-aux-Trembles",
        units: [
          {
            responsible: {
              id: 23250,
              name: "DIVISION DE LA VOIRIE",
            },
            group: {
              id: 115,
              name: "RDPPAT VOIRIE",
            },
            templates: [
              {
                id: 175,
                name: "Collecte régulière",
              },
            ],
          },
        ],
      },
      {
        id: 86,
        name: "Le Sud-Ouest",
        units: [
          {
            responsible: {
              id: 23310,
              name: "DIVISION DE LA VOIRIE",
            },
            group: {
              id: 1737,
              name: "VOIRIE OPERATIONS SUD OUEST",
            },
            templates: [
              {
                id: 175,
                name: "Collecte régulière",
              },
            ],
          },
        ],
      },
      {
        id: 82,
        name: "Mercier - Hochelaga-Maisonneuve",
        units: [
          {
            responsible: {
              id: 23356,
              name: "DIVISION DE LA VOIRIE",
            },
            group: {
              id: 682,
              name: "MHM VOIRIE",
            },
            templates: [
              {
                id: 175,
                name: "Collecte régulière",
              },
            ],
          },
        ],
      },
    ],
  },
  {
    id: 154,
    code: "TRO-GLI",
    name: "Trottoir glissant",
    type: "ACTU",
    hasForm: false,
    boroughs: [
      {
        id: 86,
        name: "Le Sud-Ouest",
        units: [
          {
            responsible: {
              id: 23310,
              name: "DIVISION DE LA VOIRIE",
            },
            group: {
              id: 1737,
              name: "VOIRIE OPERATIONS SUD OUEST",
            },
            templates: [
              {
                id: 186,
                name: "Epandage d'abrasifs & fondants",
              },
            ],
          },
        ],
      },
      {
        id: 82,
        name: "Mercier - Hochelaga-Maisonneuve",
        units: [
          {
            responsible: {
              id: 23356,
              name: "DIVISION DE LA VOIRIE",
            },
            group: {
              id: 682,
              name: "MHM VOIRIE",
            },
            templates: [
              {
                id: 186,
                name: "Epandage d'abrasifs & fondants",
              },
            ],
          },
        ],
      },
      {
        id: 1286,
        name: "L'Île-Bizard - Sainte-Geneviève",
        units: [
          {
            responsible: {
              id: 26473,
              name: "VOIRIE",
            },
            group: {
              id: 764,
              name: "IBSG VOIRIE",
            },
            templates: [
              {
                id: 186,
                name: "Epandage d'abrasifs & fondants",
              },
            ],
          },
        ],
      },
      {
        id: 1274,
        name: "Anjou",
        units: [
          {
            responsible: {
              id: 26679,
              name: "DIVISION DES TRAVAUX PUBLICS",
            },
            group: {
              id: 1407,
              name: "ANJ TRAVAUX PUBLICS OPERATIONS",
            },
            templates: [
              {
                id: 186,
                name: "Epandage d'abrasifs & fondants",
              },
            ],
          },
        ],
      },
      {
        id: 87,
        name: "Rivière-des-Prairies - Pointe-aux-Trembles",
        units: [
          {
            responsible: {
              id: 23250,
              name: "DIVISION DE LA VOIRIE",
            },
            group: {
              id: 115,
              name: "RDPPAT VOIRIE",
            },
            templates: [
              {
                id: 186,
                name: "Epandage d'abrasifs & fondants",
              },
            ],
          },
        ],
      },
      {
        id: 84,
        name: "Ville-Marie",
        units: [
          {
            responsible: {
              id: 23286,
              name: "DIVISION DE LA VOIRIE",
            },
            group: {
              id: 1895,
              name: "GROUPE TEST",
            },
            templates: [
              {
                id: 186,
                name: "Epandage d'abrasifs & fondants",
              },
              {
                id: 186,
                name: "Epandage d'abrasifs & fondants",
              },
            ],
          },
        ],
      },
    ],
  },
  {
    id: 102,
    code: "ABB-ARB",
    name: "Abattage d'arbre",
    type: "ACTU",
    hasForm: false,
    boroughs: [
      {
        id: 86,
        name: "Le Sud-Ouest",
        units: [
          {
            responsible: {
              id: 23310,
              name: "DIVISION DE LA VOIRIE",
            },
            group: {
              id: 1465,
              name: "PARC OPERATIONS SUD OUEST",
            },
            templates: [
              {
                id: 325,
                name: "Inspection abattage d'arbre",
              },
            ],
          },
        ],
      },
      {
        id: 84,
        name: "Ville-Marie",
        units: [
          {
            responsible: {
              id: 23287,
              name: "DIVISION DES PARCS ET DE L HORTICULTURE",
            },
            group: {
              id: 553,
              name: "TP PARCS HORTICULTURE VM",
            },
            templates: [
              {
                id: 325,
                name: "Inspection abattage d'arbre",
              },
            ],
          },
          {
            responsible: {
              id: 23286,
              name: "DIVISION DE LA VOIRIE",
            },
            group: {
              id: 1895,
              name: "GROUPE TEST",
            },
            templates: [
              {
                id: 325,
                name: "Inspection abattage d'arbre",
              },
            ],
          },
        ],
      },
      {
        id: 1274,
        name: "Anjou",
        units: [
          {
            responsible: {
              id: 26679,
              name: "DIVISION DES TRAVAUX PUBLICS",
            },
            group: {
              id: 1407,
              name: "ANJ TRAVAUX PUBLICS OPERATIONS",
            },
            templates: [
              {
                id: 325,
                name: "Inspection abattage d'arbre",
              },
            ],
          },
        ],
      },
    ],
  },
  {
    id: 854,
    code: "GAZ-REP",
    name: "Gazon - Réparation",
    type: "ACTU",
    hasForm: false,
    boroughs: [
      {
        id: 87,
        name: "Rivière-des-Prairies - Pointe-aux-Trembles",
        units: [
          {
            responsible: {
              id: 23250,
              name: "DIVISION DE LA VOIRIE",
            },
            group: {
              id: 115,
              name: "RDPPAT VOIRIE",
            },
            templates: [
              {
                id: 171,
                name: "Réparation de gazon",
              },
            ],
          },
        ],
      },
      {
        id: 1274,
        name: "Anjou",
        units: [
          {
            responsible: {
              id: 26679,
              name: "DIVISION DES TRAVAUX PUBLICS",
            },
            group: {
              id: 1407,
              name: "ANJ TRAVAUX PUBLICS OPERATIONS",
            },
            templates: [
              {
                id: 171,
                name: "Réparation de gazon",
              },
            ],
          },
        ],
      },
      {
        id: 1286,
        name: "L'Île-Bizard - Sainte-Geneviève",
        units: [
          {
            responsible: {
              id: 26473,
              name: "VOIRIE",
            },
            group: {
              id: 764,
              name: "IBSG VOIRIE",
            },
            templates: [
              {
                id: 171,
                name: "Réparation de gazon",
              },
            ],
          },
        ],
      },
      {
        id: 86,
        name: "Le Sud-Ouest",
        units: [
          {
            responsible: {
              id: 23310,
              name: "DIVISION DE LA VOIRIE",
            },
            group: {
              id: 1737,
              name: "VOIRIE OPERATIONS SUD OUEST",
            },
            templates: [
              {
                id: 171,
                name: "Réparation de gazon",
              },
            ],
          },
        ],
      },
      {
        id: 84,
        name: "Ville-Marie",
        units: [
          {
            responsible: {
              id: 23286,
              name: "DIVISION DE LA VOIRIE",
            },
            group: {
              id: 1895,
              name: "GROUPE TEST",
            },
            templates: [
              {
                id: 171,
                name: "Réparation de gazon",
              },
              {
                id: 171,
                name: "Réparation de gazon",
              },
            ],
          },
        ],
      },
      {
        id: 82,
        name: "Mercier - Hochelaga-Maisonneuve",
        units: [
          {
            responsible: {
              id: 23356,
              name: "DIVISION DE LA VOIRIE",
            },
            group: {
              id: 682,
              name: "MHM VOIRIE",
            },
            templates: [
              {
                id: 171,
                name: "Réparation de gazon",
              },
            ],
          },
        ],
      },
    ],
  },
  {
    id: 806,
    code: "ARB-DGR",
    name: "Danger potentiel - Arbre",
    type: "ACTU",
    hasForm: false,
    boroughs: [
      {
        id: 1274,
        name: "Anjou",
        units: [
          {
            responsible: {
              id: 26679,
              name: "DIVISION DES TRAVAUX PUBLICS",
            },
            group: {
              id: 1407,
              name: "ANJ TRAVAUX PUBLICS OPERATIONS",
            },
            templates: [
              {
                id: 337,
                name: "Arbre - Danger potentiel",
              },
            ],
          },
        ],
      },
      {
        id: 84,
        name: "Ville-Marie",
        units: [
          {
            responsible: {
              id: 23287,
              name: "DIVISION DES PARCS ET DE L HORTICULTURE",
            },
            group: {
              id: 553,
              name: "TP PARCS HORTICULTURE VM",
            },
            templates: [
              {
                id: 337,
                name: "Arbre - Danger potentiel",
              },
            ],
          },
        ],
      },
      {
        id: 86,
        name: "Le Sud-Ouest",
        units: [
          {
            responsible: {
              id: 23310,
              name: "DIVISION DE LA VOIRIE",
            },
            group: {
              id: 1465,
              name: "PARC OPERATIONS SUD OUEST",
            },
            templates: [
              {
                id: 337,
                name: "Arbre - Danger potentiel",
              },
            ],
          },
        ],
      },
    ],
  },
  {
    id: 850,
    code: "PAV-REP",
    name: "Pavage - Réparation",
    type: "ACTU",
    hasForm: false,
    boroughs: [
      {
        id: 1274,
        name: "Anjou",
        units: [
          {
            responsible: {
              id: 26679,
              name: "DIVISION DES TRAVAUX PUBLICS",
            },
            group: {
              id: 1407,
              name: "ANJ TRAVAUX PUBLICS OPERATIONS",
            },
            templates: [
              {
                id: 156,
                name: "Relevé des anomalies",
              },
            ],
          },
        ],
      },
      {
        id: 84,
        name: "Ville-Marie",
        units: [
          {
            responsible: {
              id: 23286,
              name: "DIVISION DE LA VOIRIE",
            },
            group: {
              id: 1540,
              name: "TP VOIRIE ASPHALTE",
            },
            templates: [
              {
                id: 156,
                name: "Relevé des anomalies",
              },
              {
                id: 156,
                name: "Relevé des anomalies",
              },
            ],
          },
        ],
      },
      {
        id: 1286,
        name: "L'Île-Bizard - Sainte-Geneviève",
        units: [
          {
            responsible: {
              id: 26473,
              name: "VOIRIE",
            },
            group: {
              id: 764,
              name: "IBSG VOIRIE",
            },
            templates: [
              {
                id: 156,
                name: "Relevé des anomalies",
              },
            ],
          },
        ],
      },
      {
        id: 87,
        name: "Rivière-des-Prairies - Pointe-aux-Trembles",
        units: [
          {
            responsible: {
              id: 23250,
              name: "DIVISION DE LA VOIRIE",
            },
            group: {
              id: 115,
              name: "RDPPAT VOIRIE",
            },
            templates: [
              {
                id: 156,
                name: "Relevé des anomalies",
              },
            ],
          },
        ],
      },
      {
        id: 82,
        name: "Mercier - Hochelaga-Maisonneuve",
        units: [
          {
            responsible: {
              id: 23356,
              name: "DIVISION DE LA VOIRIE",
            },
            group: {
              id: 682,
              name: "MHM VOIRIE",
            },
            templates: [
              {
                id: 156,
                name: "Relevé des anomalies",
              },
            ],
          },
        ],
      },
      {
        id: 86,
        name: "Le Sud-Ouest",
        units: [
          {
            responsible: {
              id: 23310,
              name: "DIVISION DE LA VOIRIE",
            },
            group: {
              id: 1737,
              name: "VOIRIE OPERATIONS SUD OUEST",
            },
            templates: [
              {
                id: 156,
                name: "Relevé des anomalies",
              },
            ],
          },
        ],
      },
    ],
  },
  {
    id: 76,
    code: "NET-DOM",
    name: "Nettoyage du domaine public",
    type: "ACTU",
    hasForm: false,
    boroughs: [
      {
        id: 1274,
        name: "Anjou",
        units: [
          {
            responsible: {
              id: 26679,
              name: "DIVISION DES TRAVAUX PUBLICS",
            },
            group: {
              id: 1407,
              name: "ANJ TRAVAUX PUBLICS OPERATIONS",
            },
            templates: [
              {
                id: 183,
                name: "Balayage/net. de voies et empl publ.",
              },
            ],
          },
        ],
      },
      {
        id: 82,
        name: "Mercier - Hochelaga-Maisonneuve",
        units: [
          {
            responsible: {
              id: 23356,
              name: "DIVISION DE LA VOIRIE",
            },
            group: {
              id: 682,
              name: "MHM VOIRIE",
            },
            templates: [
              {
                id: 183,
                name: "Balayage/net. de voies et empl publ.",
              },
            ],
          },
        ],
      },
      {
        id: 86,
        name: "Le Sud-Ouest",
        units: [
          {
            responsible: {
              id: 23310,
              name: "DIVISION DE LA VOIRIE",
            },
            group: {
              id: 1737,
              name: "VOIRIE OPERATIONS SUD OUEST",
            },
            templates: [
              {
                id: 183,
                name: "Balayage/net. de voies et empl publ.",
              },
            ],
          },
        ],
      },
      {
        id: 1286,
        name: "L'Île-Bizard - Sainte-Geneviève",
        units: [
          {
            responsible: {
              id: 26473,
              name: "VOIRIE",
            },
            group: {
              id: 764,
              name: "IBSG VOIRIE",
            },
            templates: [
              {
                id: 183,
                name: "Balayage/net. de voies et empl publ.",
              },
            ],
          },
        ],
      },
      {
        id: 87,
        name: "Rivière-des-Prairies - Pointe-aux-Trembles",
        units: [
          {
            responsible: {
              id: 23250,
              name: "DIVISION DE LA VOIRIE",
            },
            group: {
              id: 115,
              name: "RDPPAT VOIRIE",
            },
            templates: [
              {
                id: 183,
                name: "Balayage/net. de voies et empl publ.",
              },
            ],
          },
        ],
      },
      {
        id: 84,
        name: "Ville-Marie",
        units: [
          {
            responsible: {
              id: 23286,
              name: "DIVISION DE LA VOIRIE",
            },
            group: {
              id: 29,
              name: "TP VOIRIE VM",
            },
            templates: [
              {
                id: 183,
                name: "Balayage/net. de voies et empl publ.",
              },
            ],
          },
        ],
      },
    ],
  },
  {
    id: 109,
    code: "GAZ-PUB",
    name: "Gazon ou mauvaises herbes - Domaine public",
    type: "ACTU",
    hasForm: false,
    boroughs: [
      {
        id: 1274,
        name: "Anjou",
        units: [
          {
            responsible: {
              id: 26679,
              name: "DIVISION DES TRAVAUX PUBLICS",
            },
            group: {
              id: 1407,
              name: "ANJ TRAVAUX PUBLICS OPERATIONS",
            },
            templates: [
              {
                id: 346,
                name: "Parc - Gazon et mauvaises herbes",
              },
            ],
          },
        ],
      },
      {
        id: 84,
        name: "Ville-Marie",
        units: [
          {
            responsible: {
              id: 23287,
              name: "DIVISION DES PARCS ET DE L HORTICULTURE",
            },
            group: {
              id: 553,
              name: "TP PARCS HORTICULTURE VM",
            },
            templates: [
              {
                id: 346,
                name: "Parc - Gazon et mauvaises herbes",
              },
            ],
          },
        ],
      },
      {
        id: 86,
        name: "Le Sud-Ouest",
        units: [
          {
            responsible: {
              id: 23310,
              name: "DIVISION DE LA VOIRIE",
            },
            group: {
              id: 1465,
              name: "PARC OPERATIONS SUD OUEST",
            },
            templates: [
              {
                id: 346,
                name: "Parc - Gazon et mauvaises herbes",
              },
            ],
          },
        ],
      },
    ],
  },
  {
    id: 4389,
    code: "PAN-RUE",
    name: "Panier de rue à vider",
    type: "ACTU",
    hasForm: false,
    boroughs: [
      {
        id: 1286,
        name: "L'Île-Bizard - Sainte-Geneviève",
        units: [
          {
            responsible: {
              id: 26473,
              name: "VOIRIE",
            },
            group: {
              id: 764,
              name: "IBSG VOIRIE",
            },
            templates: [],
          },
        ],
      },
      {
        id: 82,
        name: "Mercier - Hochelaga-Maisonneuve",
        units: [
          {
            responsible: {
              id: 23356,
              name: "DIVISION DE LA VOIRIE",
            },
            group: {
              id: 682,
              name: "MHM VOIRIE",
            },
            templates: [],
          },
        ],
      },
      {
        id: 84,
        name: "Ville-Marie",
        units: [
          {
            responsible: {
              id: 23286,
              name: "DIVISION DE LA VOIRIE",
            },
            group: {
              id: 29,
              name: "TP VOIRIE VM",
            },
            templates: [],
          },
        ],
      },
      {
        id: 1274,
        name: "Anjou",
        units: [
          {
            responsible: {
              id: 26679,
              name: "DIVISION DES TRAVAUX PUBLICS",
            },
            group: {
              id: 1407,
              name: "ANJ TRAVAUX PUBLICS OPERATIONS",
            },
            templates: [],
          },
        ],
      },
      {
        id: 87,
        name: "Rivière-des-Prairies - Pointe-aux-Trembles",
        units: [
          {
            responsible: {
              id: 23250,
              name: "DIVISION DE LA VOIRIE",
            },
            group: {
              id: 115,
              name: "RDPPAT VOIRIE",
            },
            templates: [],
          },
        ],
      },
      {
        id: 86,
        name: "Le Sud-Ouest",
        units: [
          {
            responsible: {
              id: 23310,
              name: "DIVISION DE LA VOIRIE",
            },
            group: {
              id: 1737,
              name: "VOIRIE OPERATIONS SUD OUEST",
            },
            templates: [],
          },
        ],
      },
    ],
  },
  {
    id: 4386,
    code: "COL-ORG",
    name: "Collecte des matières organiques",
    type: "ACTU",
    hasForm: false,
    boroughs: [
      {
        id: 1286,
        name: "L'Île-Bizard - Sainte-Geneviève",
        units: [
          {
            responsible: {
              id: 26473,
              name: "VOIRIE",
            },
            group: {
              id: 764,
              name: "IBSG VOIRIE",
            },
            templates: [],
          },
        ],
      },
      {
        id: 1274,
        name: "Anjou",
        units: [
          {
            responsible: {
              id: 26679,
              name: "DIVISION DES TRAVAUX PUBLICS",
            },
            group: {
              id: 1407,
              name: "ANJ TRAVAUX PUBLICS OPERATIONS",
            },
            templates: [],
          },
        ],
      },
      {
        id: 82,
        name: "Mercier - Hochelaga-Maisonneuve",
        units: [
          {
            responsible: {
              id: 23356,
              name: "DIVISION DE LA VOIRIE",
            },
            group: {
              id: 682,
              name: "MHM VOIRIE",
            },
            templates: [],
          },
        ],
      },
      {
        id: 84,
        name: "Ville-Marie",
        units: [
          {
            responsible: {
              id: 23286,
              name: "DIVISION DE LA VOIRIE",
            },
            group: {
              id: 1539,
              name: "TP VOIRIE AGENTS TECHNIQUES",
            },
            templates: [],
          },
        ],
      },
      {
        id: 86,
        name: "Le Sud-Ouest",
        units: [
          {
            responsible: {
              id: 23310,
              name: "DIVISION DE LA VOIRIE",
            },
            group: {
              id: 1737,
              name: "VOIRIE OPERATIONS SUD OUEST",
            },
            templates: [],
          },
        ],
      },
      {
        id: 87,
        name: "Rivière-des-Prairies - Pointe-aux-Trembles",
        units: [
          {
            responsible: {
              id: 23250,
              name: "DIVISION DE LA VOIRIE",
            },
            group: {
              id: 115,
              name: "RDPPAT VOIRIE",
            },
            templates: [],
          },
        ],
      },
    ],
  },
  {
    id: 2933,
    code: "COL-VRT",
    name: "Collecte de résidus verts",
    type: "ACTU",
    hasForm: false,
    boroughs: [
      {
        id: 82,
        name: "Mercier - Hochelaga-Maisonneuve",
        units: [
          {
            responsible: {
              id: 23356,
              name: "DIVISION DE LA VOIRIE",
            },
            group: {
              id: 682,
              name: "MHM VOIRIE",
            },
            templates: [
              {
                id: 2025,
                name: "Environnement - Résidus verts",
              },
            ],
          },
        ],
      },
      {
        id: 86,
        name: "Le Sud-Ouest",
        units: [
          {
            responsible: {
              id: 23310,
              name: "DIVISION DE LA VOIRIE",
            },
            group: {
              id: 1737,
              name: "VOIRIE OPERATIONS SUD OUEST",
            },
            templates: [
              {
                id: 2025,
                name: "Environnement - Résidus verts",
              },
            ],
          },
        ],
      },
      {
        id: 84,
        name: "Ville-Marie",
        units: [
          {
            responsible: {
              id: 23286,
              name: "DIVISION DE LA VOIRIE",
            },
            group: {
              id: 29,
              name: "TP VOIRIE VM",
            },
            templates: [
              {
                id: 2025,
                name: "Environnement - Résidus verts",
              },
            ],
          },
        ],
      },
      {
        id: 87,
        name: "Rivière-des-Prairies - Pointe-aux-Trembles",
        units: [
          {
            responsible: {
              id: 23250,
              name: "DIVISION DE LA VOIRIE",
            },
            group: {
              id: 115,
              name: "RDPPAT VOIRIE",
            },
            templates: [
              {
                id: 2025,
                name: "Environnement - Résidus verts",
              },
            ],
          },
        ],
      },
    ],
  },
  {
    id: 77,
    code: "COL-ENC",
    name: "Collecte des encombrants",
    type: "ACTU",
    hasForm: false,
    boroughs: [
      {
        id: 84,
        name: "Ville-Marie",
        units: [
          {
            responsible: {
              id: 23286,
              name: "DIVISION DE LA VOIRIE",
            },
            group: {
              id: 1895,
              name: "GROUPE TEST",
            },
            templates: [
              {
                id: 287,
                name: "Objet volumineux (rendez-vous)",
              },
              {
                id: 287,
                name: "Objet volumineux (rendez-vous)",
              },
            ],
          },
        ],
      },
      {
        id: 82,
        name: "Mercier - Hochelaga-Maisonneuve",
        units: [
          {
            responsible: {
              id: 23356,
              name: "DIVISION DE LA VOIRIE",
            },
            group: {
              id: 682,
              name: "MHM VOIRIE",
            },
            templates: [
              {
                id: 287,
                name: "Objet volumineux (rendez-vous)",
              },
            ],
          },
        ],
      },
      {
        id: 87,
        name: "Rivière-des-Prairies - Pointe-aux-Trembles",
        units: [
          {
            responsible: {
              id: 23250,
              name: "DIVISION DE LA VOIRIE",
            },
            group: {
              id: 115,
              name: "RDPPAT VOIRIE",
            },
            templates: [
              {
                id: 287,
                name: "Objet volumineux (rendez-vous)",
              },
            ],
          },
        ],
      },
      {
        id: 86,
        name: "Le Sud-Ouest",
        units: [
          {
            responsible: {
              id: 23310,
              name: "DIVISION DE LA VOIRIE",
            },
            group: {
              id: 1737,
              name: "VOIRIE OPERATIONS SUD OUEST",
            },
            templates: [
              {
                id: 287,
                name: "Objet volumineux (rendez-vous)",
              },
            ],
          },
        ],
      },
    ],
  },
  {
    id: 849,
    code: "NID-POU",
    name: "Nid-de-poule",
    type: "ACTU",
    hasForm: false,
    boroughs: [
      {
        id: 84,
        name: "Ville-Marie",
        units: [
          {
            responsible: {
              id: 23286,
              name: "DIVISION DE LA VOIRIE",
            },
            group: {
              id: 29,
              name: "TP VOIRIE VM",
            },
            templates: [
              {
                id: 205,
                name: "Nid-de-poule",
              },
            ],
          },
        ],
      },
      {
        id: 1274,
        name: "Anjou",
        units: [
          {
            responsible: {
              id: 26679,
              name: "DIVISION DES TRAVAUX PUBLICS",
            },
            group: {
              id: 1407,
              name: "ANJ TRAVAUX PUBLICS OPERATIONS",
            },
            templates: [
              {
                id: 205,
                name: "Nid-de-poule",
              },
            ],
          },
        ],
      },
      {
        id: 86,
        name: "Le Sud-Ouest",
        units: [
          {
            responsible: {
              id: 23310,
              name: "DIVISION DE LA VOIRIE",
            },
            group: {
              id: 1737,
              name: "VOIRIE OPERATIONS SUD OUEST",
            },
            templates: [
              {
                id: 205,
                name: "Nid-de-poule",
              },
            ],
          },
        ],
      },
      {
        id: 1286,
        name: "L'Île-Bizard - Sainte-Geneviève",
        units: [
          {
            responsible: {
              id: 26473,
              name: "VOIRIE",
            },
            group: {
              id: 764,
              name: "IBSG VOIRIE",
            },
            templates: [
              {
                id: 205,
                name: "Nid-de-poule",
              },
            ],
          },
        ],
      },
      {
        id: 87,
        name: "Rivière-des-Prairies - Pointe-aux-Trembles",
        units: [
          {
            responsible: {
              id: 23250,
              name: "DIVISION DE LA VOIRIE",
            },
            group: {
              id: 115,
              name: "RDPPAT VOIRIE",
            },
            templates: [
              {
                id: 205,
                name: "Nid-de-poule",
              },
            ],
          },
        ],
      },
      {
        id: 82,
        name: "Mercier - Hochelaga-Maisonneuve",
        units: [
          {
            responsible: {
              id: 23356,
              name: "DIVISION DE LA VOIRIE",
            },
            group: {
              id: 682,
              name: "MHM VOIRIE",
            },
            templates: [
              {
                id: 205,
                name: "Nid-de-poule",
              },
            ],
          },
        ],
      },
    ],
  },
  {
    id: 1642,
    code: "ARB-DIV",
    name: "Arbre - Divers",
    type: "ACTU",
    hasForm: false,
    boroughs: [
      {
        id: 84,
        name: "Ville-Marie",
        units: [
          {
            responsible: {
              id: 23287,
              name: "DIVISION DES PARCS ET DE L HORTICULTURE",
            },
            group: {
              id: 553,
              name: "TP PARCS HORTICULTURE VM",
            },
            templates: [
              {
                id: 1157,
                name: "Varia",
              },
            ],
          },
        ],
      },
      {
        id: 1274,
        name: "Anjou",
        units: [
          {
            responsible: {
              id: 26679,
              name: "DIVISION DES TRAVAUX PUBLICS",
            },
            group: {
              id: 1407,
              name: "ANJ TRAVAUX PUBLICS OPERATIONS",
            },
            templates: [
              {
                id: 1157,
                name: "Varia",
              },
            ],
          },
        ],
      },
      {
        id: 86,
        name: "Le Sud-Ouest",
        units: [
          {
            responsible: {
              id: 23310,
              name: "DIVISION DE LA VOIRIE",
            },
            group: {
              id: 1465,
              name: "PARC OPERATIONS SUD OUEST",
            },
            templates: [
              {
                id: 1157,
                name: "Varia",
              },
            ],
          },
        ],
      },
    ],
  },
  {
    id: 104,
    code: "ARC-BRC",
    name: "Branche tombée",
    type: "ACTU",
    hasForm: false,
    boroughs: [
      {
        id: 84,
        name: "Ville-Marie",
        units: [
          {
            responsible: {
              id: 23287,
              name: "DIVISION DES PARCS ET DE L HORTICULTURE",
            },
            group: {
              id: 553,
              name: "TP PARCS HORTICULTURE VM",
            },
            templates: [
              {
                id: 336,
                name: "Arbre - Branche tombée",
              },
            ],
          },
        ],
      },
      {
        id: 86,
        name: "Le Sud-Ouest",
        units: [
          {
            responsible: {
              id: 23310,
              name: "DIVISION DE LA VOIRIE",
            },
            group: {
              id: 1465,
              name: "PARC OPERATIONS SUD OUEST",
            },
            templates: [
              {
                id: 336,
                name: "Arbre - Branche tombée",
              },
            ],
          },
        ],
      },
      {
        id: 1274,
        name: "Anjou",
        units: [
          {
            responsible: {
              id: 26679,
              name: "DIVISION DES TRAVAUX PUBLICS",
            },
            group: {
              id: 1407,
              name: "ANJ TRAVAUX PUBLICS OPERATIONS",
            },
            templates: [
              {
                id: 336,
                name: "Arbre - Branche tombée",
              },
            ],
          },
        ],
      },
    ],
  },
  {
    id: 70,
    code: "DEP-DEC",
    name: "Dépôt illégal - Déchets",
    type: "ACTU",
    hasForm: false,
    boroughs: [
      {
        id: 86,
        name: "Le Sud-Ouest",
        units: [
          {
            responsible: {
              id: 23310,
              name: "DIVISION DE LA VOIRIE",
            },
            group: {
              id: 1799,
              name: "VOIE PUBLIQUE DEPOTS ILLEGAUX",
            },
            templates: [
              {
                id: 273,
                name: "Déchets - Dépôt illégal",
              },
            ],
          },
          {
            responsible: {
              id: 23321,
              name: "DIVISION DES PERMIS ET INSPECTIONS",
            },
            group: {
              id: 1735,
              name: "PERMIS ET INSPECTIONS GDT SUD OUEST",
            },
            templates: [
              {
                id: 273,
                name: "Déchets - Dépôt illégal",
              },
            ],
          },
        ],
      },
      {
        id: 82,
        name: "Mercier - Hochelaga-Maisonneuve",
        units: [
          {
            responsible: {
              id: 23356,
              name: "DIVISION DE LA VOIRIE",
            },
            group: {
              id: 682,
              name: "MHM VOIRIE",
            },
            templates: [
              {
                id: 273,
                name: "Déchets - Dépôt illégal",
              },
            ],
          },
        ],
      },
      {
        id: 87,
        name: "Rivière-des-Prairies - Pointe-aux-Trembles",
        units: [
          {
            responsible: {
              id: 23250,
              name: "DIVISION DE LA VOIRIE",
            },
            group: {
              id: 115,
              name: "RDPPAT VOIRIE",
            },
            templates: [
              {
                id: 273,
                name: "Déchets - Dépôt illégal",
              },
            ],
          },
        ],
      },
    ],
  },
  {
    id: 427,
    code: "DEB-PUB",
    name: "Débris sur la voie publique",
    type: "ACTU",
    hasForm: false,
    boroughs: [
      {
        id: 86,
        name: "Le Sud-Ouest",
        units: [
          {
            responsible: {
              id: 23310,
              name: "DIVISION DE LA VOIRIE",
            },
            group: {
              id: 1737,
              name: "VOIRIE OPERATIONS SUD OUEST",
            },
            templates: [
              {
                id: 178,
                name: "Balayage/net. de voies et empl publ.",
              },
            ],
          },
        ],
      },
      {
        id: 84,
        name: "Ville-Marie",
        units: [
          {
            responsible: {
              id: 23286,
              name: "DIVISION DE LA VOIRIE",
            },
            group: {
              id: 29,
              name: "TP VOIRIE VM",
            },
            templates: [
              {
                id: 178,
                name: "Balayage/net. de voies et empl publ.",
              },
            ],
          },
        ],
      },
      {
        id: 1274,
        name: "Anjou",
        units: [
          {
            responsible: {
              id: 26679,
              name: "DIVISION DES TRAVAUX PUBLICS",
            },
            group: {
              id: 1407,
              name: "ANJ TRAVAUX PUBLICS OPERATIONS",
            },
            templates: [
              {
                id: 178,
                name: "Balayage/net. de voies et empl publ.",
              },
            ],
          },
        ],
      },
      {
        id: 1286,
        name: "L'Île-Bizard - Sainte-Geneviève",
        units: [
          {
            responsible: {
              id: 26473,
              name: "VOIRIE",
            },
            group: {
              id: 764,
              name: "IBSG VOIRIE",
            },
            templates: [
              {
                id: 178,
                name: "Balayage/net. de voies et empl publ.",
              },
            ],
          },
        ],
      },
      {
        id: 82,
        name: "Mercier - Hochelaga-Maisonneuve",
        units: [
          {
            responsible: {
              id: 23356,
              name: "DIVISION DE LA VOIRIE",
            },
            group: {
              id: 682,
              name: "MHM VOIRIE",
            },
            templates: [
              {
                id: 178,
                name: "Balayage/net. de voies et empl publ.",
              },
            ],
          },
        ],
      },
      {
        id: 87,
        name: "Rivière-des-Prairies - Pointe-aux-Trembles",
        units: [
          {
            responsible: {
              id: 23250,
              name: "DIVISION DE LA VOIRIE",
            },
            group: {
              id: 115,
              name: "RDPPAT VOIRIE",
            },
            templates: [
              {
                id: 178,
                name: "Balayage/net. de voies et empl publ.",
              },
            ],
          },
        ],
      },
    ],
  },
  {
    id: 63,
    code: "COL-ECR",
    name: "Collecte d'écran (ordinateur et téléviseur)",
    type: "ACTU",
    hasForm: false,
    boroughs: [
      {
        id: 86,
        name: "Le Sud-Ouest",
        units: [
          {
            responsible: {
              id: 23310,
              name: "DIVISION DE LA VOIRIE",
            },
            group: {
              id: 1737,
              name: "VOIRIE OPERATIONS SUD OUEST",
            },
            templates: [
              {
                id: 169,
                name: "Collecte déchets",
              },
            ],
          },
        ],
      },
      {
        id: 87,
        name: "Rivière-des-Prairies - Pointe-aux-Trembles",
        units: [
          {
            responsible: {
              id: 23250,
              name: "DIVISION DE LA VOIRIE",
            },
            group: {
              id: 115,
              name: "RDPPAT VOIRIE",
            },
            templates: [
              {
                id: 169,
                name: "Collecte déchets",
              },
            ],
          },
        ],
      },
      {
        id: 84,
        name: "Ville-Marie",
        units: [
          {
            responsible: {
              id: 23286,
              name: "DIVISION DE LA VOIRIE",
            },
            group: {
              id: 29,
              name: "TP VOIRIE VM",
            },
            templates: [
              {
                id: 169,
                name: "Collecte déchets",
              },
            ],
          },
        ],
      },
      {
        id: 82,
        name: "Mercier - Hochelaga-Maisonneuve",
        units: [
          {
            responsible: {
              id: 23356,
              name: "DIVISION DE LA VOIRIE",
            },
            group: {
              id: 682,
              name: "MHM VOIRIE",
            },
            templates: [
              {
                id: 169,
                name: "Collecte déchets",
              },
            ],
          },
        ],
      },
    ],
  },
  {
    id: 150,
    code: "CHA-GLI",
    name: "Chaussée glissante",
    type: "ACTU",
    hasForm: false,
    boroughs: [
      {
        id: 86,
        name: "Le Sud-Ouest",
        units: [
          {
            responsible: {
              id: 23310,
              name: "DIVISION DE LA VOIRIE",
            },
            group: {
              id: 1737,
              name: "VOIRIE OPERATIONS SUD OUEST",
            },
            templates: [
              {
                id: 167,
                name: "Épandage d'abrasifs et fondants",
              },
            ],
          },
        ],
      },
      {
        id: 82,
        name: "Mercier - Hochelaga-Maisonneuve",
        units: [
          {
            responsible: {
              id: 23356,
              name: "DIVISION DE LA VOIRIE",
            },
            group: {
              id: 682,
              name: "MHM VOIRIE",
            },
            templates: [
              {
                id: 167,
                name: "Épandage d'abrasifs et fondants",
              },
            ],
          },
        ],
      },
      {
        id: 84,
        name: "Ville-Marie",
        units: [
          {
            responsible: {
              id: 23286,
              name: "DIVISION DE LA VOIRIE",
            },
            group: {
              id: 29,
              name: "TP VOIRIE VM",
            },
            templates: [
              {
                id: 167,
                name: "Épandage d'abrasifs et fondants",
              },
            ],
          },
        ],
      },
      {
        id: 1274,
        name: "Anjou",
        units: [
          {
            responsible: {
              id: 26679,
              name: "DIVISION DES TRAVAUX PUBLICS",
            },
            group: {
              id: 1407,
              name: "ANJ TRAVAUX PUBLICS OPERATIONS",
            },
            templates: [
              {
                id: 167,
                name: "Épandage d'abrasifs et fondants",
              },
            ],
          },
        ],
      },
      {
        id: 87,
        name: "Rivière-des-Prairies - Pointe-aux-Trembles",
        units: [
          {
            responsible: {
              id: 23250,
              name: "DIVISION DE LA VOIRIE",
            },
            group: {
              id: 115,
              name: "RDPPAT VOIRIE",
            },
            templates: [
              {
                id: 167,
                name: "Épandage d'abrasifs et fondants",
              },
            ],
          },
        ],
      },
      {
        id: 1286,
        name: "L'Île-Bizard - Sainte-Geneviève",
        units: [
          {
            responsible: {
              id: 26473,
              name: "VOIRIE",
            },
            group: {
              id: 764,
              name: "IBSG VOIRIE",
            },
            templates: [
              {
                id: 167,
                name: "Épandage d'abrasifs et fondants",
              },
            ],
          },
        ],
      },
    ],
  },
  {
    id: 105,
    code: "DOM-ARB",
    name: "Dommage - Racines d'arbres",
    type: "ACTU",
    hasForm: false,
    boroughs: [
      {
        id: 86,
        name: "Le Sud-Ouest",
        units: [
          {
            responsible: {
              id: 23310,
              name: "DIVISION DE LA VOIRIE",
            },
            group: {
              id: 1465,
              name: "PARC OPERATIONS SUD OUEST",
            },
            templates: [
              {
                id: 328,
                name: "Inspection dommage à un arbre",
              },
            ],
          },
        ],
      },
      {
        id: 84,
        name: "Ville-Marie",
        units: [
          {
            responsible: {
              id: 23287,
              name: "DIVISION DES PARCS ET DE L HORTICULTURE",
            },
            group: {
              id: 553,
              name: "TP PARCS HORTICULTURE VM",
            },
            templates: [
              {
                id: 328,
                name: "Inspection dommage à un arbre",
              },
            ],
          },
        ],
      },
      {
        id: 1274,
        name: "Anjou",
        units: [
          {
            responsible: {
              id: 26679,
              name: "DIVISION DES TRAVAUX PUBLICS",
            },
            group: {
              id: 1407,
              name: "ANJ TRAVAUX PUBLICS OPERATIONS",
            },
            templates: [
              {
                id: 328,
                name: "Inspection dommage à un arbre",
              },
            ],
          },
        ],
      },
    ],
  },
  {
    id: 4388,
    code: "PAN-PRC",
    name: "Panier de parc à vider",
    type: "ACTU",
    hasForm: false,
    boroughs: [
      {
        id: 87,
        name: "Rivière-des-Prairies - Pointe-aux-Trembles",
        units: [
          {
            responsible: {
              id: 23250,
              name: "DIVISION DE LA VOIRIE",
            },
            group: {
              id: 115,
              name: "RDPPAT VOIRIE",
            },
            templates: [],
          },
        ],
      },
      {
        id: 86,
        name: "Le Sud-Ouest",
        units: [
          {
            responsible: {
              id: 23310,
              name: "DIVISION DE LA VOIRIE",
            },
            group: {
              id: 1737,
              name: "VOIRIE OPERATIONS SUD OUEST",
            },
            templates: [],
          },
        ],
      },
      {
        id: 1286,
        name: "L'Île-Bizard - Sainte-Geneviève",
        units: [
          {
            responsible: {
              id: 26473,
              name: "VOIRIE",
            },
            group: {
              id: 764,
              name: "IBSG VOIRIE",
            },
            templates: [],
          },
        ],
      },
      {
        id: 82,
        name: "Mercier - Hochelaga-Maisonneuve",
        units: [
          {
            responsible: {
              id: 23356,
              name: "DIVISION DE LA VOIRIE",
            },
            group: {
              id: 682,
              name: "MHM VOIRIE",
            },
            templates: [],
          },
        ],
      },
      {
        id: 84,
        name: "Ville-Marie",
        units: [
          {
            responsible: {
              id: 23286,
              name: "DIVISION DE LA VOIRIE",
            },
            group: {
              id: 29,
              name: "TP VOIRIE VM",
            },
            templates: [],
          },
        ],
      },
      {
        id: 1274,
        name: "Anjou",
        units: [
          {
            responsible: {
              id: 26679,
              name: "DIVISION DES TRAVAUX PUBLICS",
            },
            group: {
              id: 1407,
              name: "ANJ TRAVAUX PUBLICS OPERATIONS",
            },
            templates: [],
          },
        ],
      },
    ],
  },
  {
    id: 3622,
    code: "COL-ALI",
    name: "Collecte de résidus alimentaires",
    type: "ACTU",
    hasForm: false,
    boroughs: [
      {
        id: 87,
        name: "Rivière-des-Prairies - Pointe-aux-Trembles",
        units: [
          {
            responsible: {
              id: 23250,
              name: "DIVISION DE LA VOIRIE",
            },
            group: {
              id: 115,
              name: "RDPPAT VOIRIE",
            },
            templates: [],
          },
        ],
      },
      {
        id: 86,
        name: "Le Sud-Ouest",
        units: [
          {
            responsible: {
              id: 23310,
              name: "DIVISION DE LA VOIRIE",
            },
            group: {
              id: 1737,
              name: "VOIRIE OPERATIONS SUD OUEST",
            },
            templates: [],
          },
        ],
      },
      {
        id: 82,
        name: "Mercier - Hochelaga-Maisonneuve",
        units: [
          {
            responsible: {
              id: 23356,
              name: "DIVISION DE LA VOIRIE",
            },
            group: {
              id: 682,
              name: "MHM VOIRIE",
            },
            templates: [],
          },
        ],
      },
    ],
  },
  {
    id: 2765,
    code: "GRA-HAI",
    name: "Graffitis haineux",
    type: "ACTU",
    hasForm: false,
    boroughs: [
      {
        id: 87,
        name: "Rivière-des-Prairies - Pointe-aux-Trembles",
        units: [
          {
            responsible: {
              id: 23250,
              name: "DIVISION DE LA VOIRIE",
            },
            group: {
              id: 115,
              name: "RDPPAT VOIRIE",
            },
            templates: [
              {
                id: 1879,
                name: "graffitis haineux",
              },
            ],
          },
        ],
      },
      {
        id: 86,
        name: "Le Sud-Ouest",
        units: [
          {
            responsible: {
              id: 23310,
              name: "DIVISION DE LA VOIRIE",
            },
            group: {
              id: 1465,
              name: "PARC OPERATIONS SUD OUEST",
            },
            templates: [
              {
                id: 1879,
                name: "graffitis haineux",
              },
            ],
          },
        ],
      },
      {
        id: 82,
        name: "Mercier - Hochelaga-Maisonneuve",
        units: [
          {
            responsible: {
              id: 23356,
              name: "DIVISION DE LA VOIRIE",
            },
            group: {
              id: 682,
              name: "MHM VOIRIE",
            },
            templates: [
              {
                id: 1879,
                name: "graffitis haineux",
              },
            ],
          },
        ],
      },
    ],
  },
  {
    id: 64,
    code: "COL-REC",
    name: "Collecte des matières recyclables",
    type: "ACTU",
    hasForm: false,
    boroughs: [
      {
        id: 87,
        name: "Rivière-des-Prairies - Pointe-aux-Trembles",
        units: [
          {
            responsible: {
              id: 23250,
              name: "DIVISION DE LA VOIRIE",
            },
            group: {
              id: 115,
              name: "RDPPAT VOIRIE",
            },
            templates: [
              {
                id: 213,
                name: "Collecte sélective",
              },
            ],
          },
        ],
      },
      {
        id: 82,
        name: "Mercier - Hochelaga-Maisonneuve",
        units: [
          {
            responsible: {
              id: 23356,
              name: "DIVISION DE LA VOIRIE",
            },
            group: {
              id: 682,
              name: "MHM VOIRIE",
            },
            templates: [
              {
                id: 213,
                name: "Collecte sélective",
              },
            ],
          },
        ],
      },
      {
        id: 84,
        name: "Ville-Marie",
        units: [
          {
            responsible: {
              id: 23286,
              name: "DIVISION DE LA VOIRIE",
            },
            group: {
              id: 29,
              name: "TP VOIRIE VM",
            },
            templates: [
              {
                id: 213,
                name: "Collecte sélective",
              },
            ],
          },
        ],
      },
      {
        id: 86,
        name: "Le Sud-Ouest",
        units: [
          {
            responsible: {
              id: 23310,
              name: "DIVISION DE LA VOIRIE",
            },
            group: {
              id: 1737,
              name: "VOIRIE OPERATIONS SUD OUEST",
            },
            templates: [
              {
                id: 213,
                name: "Collecte sélective",
              },
            ],
          },
        ],
      },
    ],
  },
  {
    id: 4390,
    code: "SIG-ENT",
    name: "Signalisation écrite - Entretien",
    type: "ACTU",
    hasForm: false,
    boroughs: [
      {
        id: 1274,
        name: "Anjou",
        units: [
          {
            responsible: {
              id: 26679,
              name: "DIVISION DES TRAVAUX PUBLICS",
            },
            group: {
              id: 1407,
              name: "ANJ TRAVAUX PUBLICS OPERATIONS",
            },
            templates: [],
          },
        ],
      },
      {
        id: 82,
        name: "Mercier - Hochelaga-Maisonneuve",
        units: [
          {
            responsible: {
              id: 23356,
              name: "DIVISION DE LA VOIRIE",
            },
            group: {
              id: 682,
              name: "MHM VOIRIE",
            },
            templates: [],
          },
        ],
      },
      {
        id: 1286,
        name: "L'Île-Bizard - Sainte-Geneviève",
        units: [
          {
            responsible: {
              id: 26473,
              name: "VOIRIE",
            },
            group: {
              id: 764,
              name: "IBSG VOIRIE",
            },
            templates: [],
          },
        ],
      },
      {
        id: 84,
        name: "Ville-Marie",
        units: [
          {
            responsible: {
              id: 23286,
              name: "DIVISION DE LA VOIRIE",
            },
            group: {
              id: 29,
              name: "TP VOIRIE VM",
            },
            templates: [],
          },
        ],
      },
      {
        id: 86,
        name: "Le Sud-Ouest",
        units: [
          {
            responsible: {
              id: 23310,
              name: "DIVISION DE LA VOIRIE",
            },
            group: {
              id: 1737,
              name: "VOIRIE OPERATIONS SUD OUEST",
            },
            templates: [],
          },
        ],
      },
      {
        id: 87,
        name: "Rivière-des-Prairies - Pointe-aux-Trembles",
        units: [
          {
            responsible: {
              id: 23250,
              name: "DIVISION DE LA VOIRIE",
            },
            group: {
              id: 115,
              name: "RDPPAT VOIRIE",
            },
            templates: [],
          },
        ],
      },
    ],
  },
  {
    id: 653,
    code: "VAN-ARB",
    name: "Vandalisme ou accident - Arbre",
    type: "ACTU",
    hasForm: false,
    boroughs: [
      {
        id: 1274,
        name: "Anjou",
        units: [
          {
            responsible: {
              id: 26679,
              name: "DIVISION DES TRAVAUX PUBLICS",
            },
            group: {
              id: 1407,
              name: "ANJ TRAVAUX PUBLICS OPERATIONS",
            },
            templates: [
              {
                id: 327,
                name: "Inspection arbre vandalisme",
              },
            ],
          },
        ],
      },
      {
        id: 84,
        name: "Ville-Marie",
        units: [
          {
            responsible: {
              id: 23287,
              name: "DIVISION DES PARCS ET DE L HORTICULTURE",
            },
            group: {
              id: 553,
              name: "TP PARCS HORTICULTURE VM",
            },
            templates: [
              {
                id: 327,
                name: "Inspection arbre vandalisme",
              },
            ],
          },
        ],
      },
      {
        id: 86,
        name: "Le Sud-Ouest",
        units: [
          {
            responsible: {
              id: 23310,
              name: "DIVISION DE LA VOIRIE",
            },
            group: {
              id: 1465,
              name: "PARC OPERATIONS SUD OUEST",
            },
            templates: [
              {
                id: 327,
                name: "Inspection arbre vandalisme",
              },
            ],
          },
        ],
      },
    ],
  },
  {
    id: 4385,
    code: "PUI-1RE",
    name: "Puisard - Première intervention",
    type: "ACTU",
    hasForm: false,
    boroughs: [
      {
        id: 82,
        name: "Mercier - Hochelaga-Maisonneuve",
        units: [
          {
            responsible: {
              id: 23356,
              name: "DIVISION DE LA VOIRIE",
            },
            group: {
              id: 682,
              name: "MHM VOIRIE",
            },
            templates: [],
          },
        ],
      },
      {
        id: 84,
        name: "Ville-Marie",
        units: [
          {
            responsible: {
              id: 23286,
              name: "DIVISION DE LA VOIRIE",
            },
            group: {
              id: 1539,
              name: "TP VOIRIE AGENTS TECHNIQUES",
            },
            templates: [],
          },
        ],
      },
      {
        id: 1274,
        name: "Anjou",
        units: [
          {
            responsible: {
              id: 26679,
              name: "DIVISION DES TRAVAUX PUBLICS",
            },
            group: {
              id: 1407,
              name: "ANJ TRAVAUX PUBLICS OPERATIONS",
            },
            templates: [],
          },
        ],
      },
      {
        id: 86,
        name: "Le Sud-Ouest",
        units: [
          {
            responsible: {
              id: 23310,
              name: "DIVISION DE LA VOIRIE",
            },
            group: {
              id: 1737,
              name: "VOIRIE OPERATIONS SUD OUEST",
            },
            templates: [],
          },
        ],
      },
      {
        id: 1286,
        name: "L'Île-Bizard - Sainte-Geneviève",
        units: [
          {
            responsible: {
              id: 26473,
              name: "VOIRIE",
            },
            group: {
              id: 764,
              name: "IBSG VOIRIE",
            },
            templates: [],
          },
        ],
      },
      {
        id: 87,
        name: "Rivière-des-Prairies - Pointe-aux-Trembles",
        units: [
          {
            responsible: {
              id: 23250,
              name: "DIVISION DE LA VOIRIE",
            },
            group: {
              id: 115,
              name: "RDPPAT VOIRIE",
            },
            templates: [],
          },
        ],
      },
    ],
  },
  {
    id: 2104,
    code: "ARB-TBE",
    name: "Arbre tombé",
    type: "ACTU",
    hasForm: false,
    boroughs: [
      {
        id: 84,
        name: "Ville-Marie",
        units: [
          {
            responsible: {
              id: 23287,
              name: "DIVISION DES PARCS ET DE L HORTICULTURE",
            },
            group: {
              id: 553,
              name: "TP PARCS HORTICULTURE VM",
            },
            templates: [
              {
                id: 1578,
                name: "Arbre - Entretien",
              },
            ],
          },
        ],
      },
      {
        id: 1274,
        name: "Anjou",
        units: [
          {
            responsible: {
              id: 26679,
              name: "DIVISION DES TRAVAUX PUBLICS",
            },
            group: {
              id: 1407,
              name: "ANJ TRAVAUX PUBLICS OPERATIONS",
            },
            templates: [
              {
                id: 1578,
                name: "Arbre - Entretien",
              },
            ],
          },
        ],
      },
      {
        id: 86,
        name: "Le Sud-Ouest",
        units: [
          {
            responsible: {
              id: 23310,
              name: "DIVISION DE LA VOIRIE",
            },
            group: {
              id: 1465,
              name: "PARC OPERATIONS SUD OUEST",
            },
            templates: [
              {
                id: 1578,
                name: "Arbre - Entretien",
              },
            ],
          },
        ],
      },
    ],
  },
  {
    id: 1643,
    code: "HOR-DIV",
    name: "Horticulture - Divers",
    type: "ACTU",
    hasForm: false,
    boroughs: [
      {
        id: 86,
        name: "Le Sud-Ouest",
        units: [
          {
            responsible: {
              id: 23310,
              name: "DIVISION DE LA VOIRIE",
            },
            group: {
              id: 1465,
              name: "PARC OPERATIONS SUD OUEST",
            },
            templates: [
              {
                id: 1593,
                name: "Horticulture varia",
              },
            ],
          },
        ],
      },
      {
        id: 1274,
        name: "Anjou",
        units: [
          {
            responsible: {
              id: 26679,
              name: "DIVISION DES TRAVAUX PUBLICS",
            },
            group: {
              id: 1407,
              name: "ANJ TRAVAUX PUBLICS OPERATIONS",
            },
            templates: [
              {
                id: 1593,
                name: "Horticulture varia",
              },
            ],
          },
        ],
      },
      {
        id: 84,
        name: "Ville-Marie",
        units: [
          {
            responsible: {
              id: 23287,
              name: "DIVISION DES PARCS ET DE L HORTICULTURE",
            },
            group: {
              id: 553,
              name: "TP PARCS HORTICULTURE VM",
            },
            templates: [
              {
                id: 1593,
                name: "Horticulture varia",
              },
            ],
          },
        ],
      },
    ],
  },
  {
    id: 110,
    code: "PLA-ARB",
    name: "Plantation d'arbre",
    type: "ACTU",
    hasForm: false,
    boroughs: [
      {
        id: 1274,
        name: "Anjou",
        units: [
          {
            responsible: {
              id: 26679,
              name: "DIVISION DES TRAVAUX PUBLICS",
            },
            group: {
              id: 1407,
              name: "ANJ TRAVAUX PUBLICS OPERATIONS",
            },
            templates: [
              {
                id: 348,
                name: "Arbre - Plantation",
              },
            ],
          },
        ],
      },
      {
        id: 84,
        name: "Ville-Marie",
        units: [
          {
            responsible: {
              id: 23287,
              name: "DIVISION DES PARCS ET DE L HORTICULTURE",
            },
            group: {
              id: 553,
              name: "TP PARCS HORTICULTURE VM",
            },
            templates: [
              {
                id: 348,
                name: "Arbre - Plantation",
              },
            ],
          },
          {
            responsible: {
              id: 23286,
              name: "DIVISION DE LA VOIRIE",
            },
            group: {
              id: 1895,
              name: "GROUPE TEST",
            },
            templates: [
              {
                id: 348,
                name: "Arbre - Plantation",
              },
            ],
          },
        ],
      },
      {
        id: 86,
        name: "Le Sud-Ouest",
        units: [
          {
            responsible: {
              id: 23310,
              name: "DIVISION DE LA VOIRIE",
            },
            group: {
              id: 1465,
              name: "PARC OPERATIONS SUD OUEST",
            },
            templates: [
              {
                id: 348,
                name: "Arbre - Plantation",
              },
            ],
          },
        ],
      },
    ],
  },
  {
    id: 50,
    code: "ECL-EXI",
    name: "Éclairage existant - Entretien",
    type: "ACTU",
    hasForm: false,
    boroughs: [
      {
        id: 1274,
        name: "Anjou",
        units: [
          {
            responsible: {
              id: 26679,
              name: "DIVISION DES TRAVAUX PUBLICS",
            },
            group: {
              id: 1407,
              name: "ANJ TRAVAUX PUBLICS OPERATIONS",
            },
            templates: [
              {
                id: 468,
                name: "Éclairage",
              },
            ],
          },
        ],
      },
      {
        id: 86,
        name: "Le Sud-Ouest",
        units: [
          {
            responsible: {
              id: 23310,
              name: "DIVISION DE LA VOIRIE",
            },
            group: {
              id: 1737,
              name: "VOIRIE OPERATIONS SUD OUEST",
            },
            templates: [
              {
                id: 468,
                name: "Éclairage",
              },
            ],
          },
        ],
      },
      {
        id: 87,
        name: "Rivière-des-Prairies - Pointe-aux-Trembles",
        units: [
          {
            responsible: {
              id: 23250,
              name: "DIVISION DE LA VOIRIE",
            },
            group: {
              id: 115,
              name: "RDPPAT VOIRIE",
            },
            templates: [
              {
                id: 468,
                name: "Éclairage",
              },
            ],
          },
        ],
      },
      {
        id: 1286,
        name: "L'Île-Bizard - Sainte-Geneviève",
        units: [
          {
            responsible: {
              id: 26473,
              name: "VOIRIE",
            },
            group: {
              id: 764,
              name: "IBSG VOIRIE",
            },
            templates: [
              {
                id: 468,
                name: "Éclairage",
              },
            ],
          },
        ],
      },
    ],
  },
  {
    id: 366,
    code: "ESS-ARB",
    name: "Essouchement",
    type: "ACTU",
    hasForm: false,
    boroughs: [
      {
        id: 86,
        name: "Le Sud-Ouest",
        units: [
          {
            responsible: {
              id: 23310,
              name: "DIVISION DE LA VOIRIE",
            },
            group: {
              id: 1465,
              name: "PARC OPERATIONS SUD OUEST",
            },
            templates: [
              {
                id: 330,
                name: "Inspection enlèvement de souche",
              },
            ],
          },
        ],
      },
      {
        id: 84,
        name: "Ville-Marie",
        units: [
          {
            responsible: {
              id: 23287,
              name: "DIVISION DES PARCS ET DE L HORTICULTURE",
            },
            group: {
              id: 553,
              name: "TP PARCS HORTICULTURE VM",
            },
            templates: [
              {
                id: 330,
                name: "Inspection enlèvement de souche",
              },
            ],
          },
        ],
      },
      {
        id: 1274,
        name: "Anjou",
        units: [
          {
            responsible: {
              id: 26679,
              name: "DIVISION DES TRAVAUX PUBLICS",
            },
            group: {
              id: 1407,
              name: "ANJ TRAVAUX PUBLICS OPERATIONS",
            },
            templates: [
              {
                id: 330,
                name: "Inspection enlèvement de souche",
              },
            ],
          },
        ],
      },
    ],
  },
  {
    id: 837,
    code: "EXT-INS",
    name: "Extermination à l'extérieur - Insectes",
    type: "ACTU",
    hasForm: false,
    boroughs: [
      {
        id: 86,
        name: "Le Sud-Ouest",
        units: [
          {
            responsible: {
              id: 23310,
              name: "DIVISION DE LA VOIRIE",
            },
            group: {
              id: 1465,
              name: "PARC OPERATIONS SUD OUEST",
            },
            templates: [
              {
                id: 349,
                name: "Arboriculture - Extermination insectes",
              },
            ],
          },
        ],
      },
      {
        id: 84,
        name: "Ville-Marie",
        units: [
          {
            responsible: {
              id: 23356,
              name: "DIVISION DE LA VOIRIE",
            },
            group: {
              id: 682,
              name: "MHM VOIRIE",
            },
            templates: [
              {
                id: 349,
                name: "Arboriculture - Extermination insectes",
              },
            ],
          },
          {
            responsible: {
              id: 23287,
              name: "DIVISION DES PARCS ET DE L HORTICULTURE",
            },
            group: {
              id: 553,
              name: "TP PARCS HORTICULTURE VM",
            },
            templates: [
              {
                id: 349,
                name: "Arboriculture - Extermination insectes",
              },
            ],
          },
        ],
      },
    ],
  },
  {
    id: 3752,
    code: "OPE-NEI",
    name: "Opération déneigement",
    type: "ACTU",
    hasForm: false,
    boroughs: [
      {
        id: 82,
        name: "Mercier - Hochelaga-Maisonneuve",
        units: [
          {
            responsible: {
              id: 23356,
              name: "DIVISION DE LA VOIRIE",
            },
            group: {
              id: 682,
              name: "MHM VOIRIE",
            },
            templates: [],
          },
        ],
      },
      {
        id: 86,
        name: "Le Sud-Ouest",
        units: [
          {
            responsible: {
              id: 23310,
              name: "DIVISION DE LA VOIRIE",
            },
            group: {
              id: 1737,
              name: "VOIRIE OPERATIONS SUD OUEST",
            },
            templates: [],
          },
        ],
      },
      {
        id: 84,
        name: "Ville-Marie",
        units: [
          {
            responsible: {
              id: 23286,
              name: "DIVISION DE LA VOIRIE",
            },
            group: {
              id: 29,
              name: "TP VOIRIE VM",
            },
            templates: [],
          },
        ],
      },
      {
        id: 1274,
        name: "Anjou",
        units: [
          {
            responsible: {
              id: 24066,
              name: "DIRECTION DES TRAVAUX PUBLICS",
            },
            group: {
              id: 1562,
              name: "AGENTS BUREAU TRAVAUX PUBLICS ANJOU",
            },
            templates: [],
          },
        ],
      },
      {
        id: 87,
        name: "Rivière-des-Prairies - Pointe-aux-Trembles",
        units: [
          {
            responsible: {
              id: 23250,
              name: "DIVISION DE LA VOIRIE",
            },
            group: {
              id: 115,
              name: "RDPPAT VOIRIE",
            },
            templates: [],
          },
        ],
      },
    ],
  },
  {
    id: 3756,
    code: "SIG-NEI",
    name: "Signalisation - Neige",
    type: "ACTU",
    hasForm: false,
    boroughs: [
      {
        id: 82,
        name: "Mercier - Hochelaga-Maisonneuve",
        units: [
          {
            responsible: {
              id: 23356,
              name: "DIVISION DE LA VOIRIE",
            },
            group: {
              id: 682,
              name: "MHM VOIRIE",
            },
            templates: [],
          },
        ],
      },
      {
        id: 86,
        name: "Le Sud-Ouest",
        units: [
          {
            responsible: {
              id: 23310,
              name: "DIVISION DE LA VOIRIE",
            },
            group: {
              id: 1737,
              name: "VOIRIE OPERATIONS SUD OUEST",
            },
            templates: [],
          },
        ],
      },
      {
        id: 87,
        name: "Rivière-des-Prairies - Pointe-aux-Trembles",
        units: [
          {
            responsible: {
              id: 23250,
              name: "DIVISION DE LA VOIRIE",
            },
            group: {
              id: 115,
              name: "RDPPAT VOIRIE",
            },
            templates: [],
          },
        ],
      },
      {
        id: 1274,
        name: "Anjou",
        units: [
          {
            responsible: {
              id: 26679,
              name: "DIVISION DES TRAVAUX PUBLICS",
            },
            group: {
              id: 1407,
              name: "ANJ TRAVAUX PUBLICS OPERATIONS",
            },
            templates: [],
          },
        ],
      },
      {
        id: 84,
        name: "Ville-Marie",
        units: [
          {
            responsible: {
              id: 23286,
              name: "DIVISION DE LA VOIRIE",
            },
            group: {
              id: 29,
              name: "TP VOIRIE VM",
            },
            templates: [],
          },
        ],
      },
    ],
  },
  {
    id: 215,
    code: "AME-PAR",
    name: "Aménagement de parc",
    type: "ACTU",
    hasForm: false,
    boroughs: [
      {
        id: 86,
        name: "Le Sud-Ouest",
        units: [
          {
            responsible: {
              id: 23312,
              name: "DIVISION DES ÉTUDES TECHNIQUES",
            },
            group: {
              id: 1743,
              name: "ETUDES TECHNIQUES SUD OUEST",
            },
            templates: [
              {
                id: 222,
                name: "Parc - Aménagement",
              },
            ],
          },
        ],
      },
    ],
  },
  {
    id: 1644,
    code: "CHA-PRC",
    name: "Chalet de parc",
    type: "ACTU",
    hasForm: false,
    boroughs: [
      {
        id: 86,
        name: "Le Sud-Ouest",
        units: [
          {
            responsible: {
              id: 23310,
              name: "DIVISION DE LA VOIRIE",
            },
            group: {
              id: 1465,
              name: "PARC OPERATIONS SUD OUEST",
            },
            templates: [
              {
                id: 1596,
                name: "Parc Chalet",
              },
            ],
          },
        ],
      },
      {
        id: 84,
        name: "Ville-Marie",
        units: [
          {
            responsible: {
              id: 23287,
              name: "DIVISION DES PARCS ET DE L HORTICULTURE",
            },
            group: {
              id: 553,
              name: "TP PARCS HORTICULTURE VM",
            },
            templates: [
              {
                id: 1596,
                name: "Parc Chalet",
              },
            ],
          },
        ],
      },
    ],
  },
  {
    id: 216,
    code: "MOB-PAR",
    name: "Mobilier de parc",
    type: "ACTU",
    hasForm: false,
    boroughs: [
      {
        id: 84,
        name: "Ville-Marie",
        units: [
          {
            responsible: {
              id: 23287,
              name: "DIVISION DES PARCS ET DE L HORTICULTURE",
            },
            group: {
              id: 553,
              name: "TP PARCS HORTICULTURE VM",
            },
            templates: [
              {
                id: 350,
                name: "Parc - Mobilier",
              },
            ],
          },
        ],
      },
      {
        id: 86,
        name: "Le Sud-Ouest",
        units: [
          {
            responsible: {
              id: 23310,
              name: "DIVISION DE LA VOIRIE",
            },
            group: {
              id: 1465,
              name: "PARC OPERATIONS SUD OUEST",
            },
            templates: [
              {
                id: 350,
                name: "Parc - Mobilier",
              },
            ],
          },
        ],
      },
    ],
  },
];
// export const mockCurrentUserAllowableActivities: IAllowableActivityDTO[] = [
//   {
//     id: 429,
//     code: "COL-ENR",
//     name: "Encombrants non ramassés",
//     boroughs: [
//       {
//         id: 84,
//         name: "Ville-Marie",
//         groups: [
//           {
//             id: 29,
//             name: "TP VOIRIE VM",
//           },
//           {
//             id: 30,
//             name: "TP VOIRIE VM2",
//           },
//         ],
//       },
//       {
//         id: 87,
//         name: "Rivière-des-Prairies - Pointe-aux-Trembles",
//         groups: [
//           {
//             id: 30,
//             name: "TP VOIRIE VM2",
//           },
//         ],
//       },
//     ],
//   },
//   {
//     id: 73,
//     code: "GRA-DOM",
//     name: "Graffitis - Domaine public",
//     boroughs: [
//       {
//         id: 84,
//         name: "Ville-Marie",
//         groups: [
//           {
//             id: 29,
//             name: "TP VOIRIE VM",
//           },
//           {
//             id: 29,
//             name: "TP VOIRIE VM",
//           },
//         ],
//       },
//     ],
//   },
//   {
//     id: 61,
//     code: "BAL-MEC",
//     name: "Balai mécanique",
//     boroughs: [
//       {
//         id: 87,
//         name: "Rivière-des-Prairies - Pointe-aux-Trembles",
//         groups: [
//           {
//             id: 115,
//             name: "RDPPAT VOIRIE",
//           },
//         ],
//       },
//     ],
//   },
// ];
